import React, { useState, useEffect, useMemo } from 'react';
import { Autocomplete, FormControlLabel, Typography, TextField, Table, TableBody, TableCell, TableContainer, Box, CircularProgress, TableHead, TableRow, Paper, Button, TablePagination, Checkbox, Grid, Modal, Alert, Dialog, DialogTitle, DialogContent, DialogActions, TableSortLabel, Tooltip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import GestionCotizaciones from './GestionCotizacion'; // Asegúrate de que la ruta sea correcta
import GestionOrdenTrabajo from './GestionOrdenTrabajo';
import Swal from 'sweetalert2';
import GestionFactura from './GestionFactura'; // Ajusta la ruta si es necesario
import dayjs from 'dayjs';
import Resultados from './Resultados';
import { useSucursal } from '../contexts/SucursalContext';
import { useUser } from '../contexts/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt, faEnvelope, faPrint } from '@fortawesome/free-solid-svg-icons';
import { CheckBox, CheckBoxOutlineBlank, Warning } from '@mui/icons-material';
import TomaMuestra from '../Analisis/TomaMuestra';
import ComentariosEntregaModal from './ComentariosEntregaModal';
import PdfPreviewModal from './PdfPreviewModal';
import SobrePreviewModal from './SobrePreviewModal';
import {useAccesos} from '../contexts/AccesosContext'
const swalWithHighZIndex = Swal.mixin({
    zIndex: 9999
});

function OrdenesTrabajo() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [ordenesTrabajo, setOrdenesTrabajo] = useState([]);
    const [totalOrdenesTrabajo, setTotalOrdenesTrabajo] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [selectedOrdenTrabajo, setSelectedOrdenTrabajo] = useState(null);

    // Estados separados para la paginación de la tabla de detalles - ELIMINADOS PARA MOSTRAR TODOS LOS ANÁLISIS

    const [openModal, setOpenModal] = useState(false);
    const [ordenTrabajoData, setOrdenTrabajoData] = useState(null);
    const [detallesOrdenTrabajo, setDetallesOrdenTrabajo] = useState([]);
    const [detallesOrdenTrabajoInfo, setDetallesOrdenTrabajoInfo] = useState([]);
    const [openFacturaModal, setOpenFacturaModal] = useState(false);
    const [facturaData, setFacturaData] = useState(null);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
    const [loading, setLoading] = useState(false); 
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [sucursales, setSucursales] = useState([]);
    const { sucursalSeleccionada, cajaAbierta } = useSucursal(); // ✅ Solo lectura, NO modificamos la sesión
    const [sucursalFiltro, setSucursalFiltro] = useState(null); // ✅ Variable local para filtro de pantalla
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [abreviatura, setAbreviatura] = useState('');

    const [openResultadosModal, setOpenResultadosModal] = useState(false);
    const [numericCodigo, setNumericCodigo] = useState(null);
    const [selectedModulo, setSelectedModulo] = useState(null); // Nuevo estado para Módulo
    const [modulos, setModulos] = useState([]); // Estado para guardar los módulos obtenidos
    const { user } = useUser();
    const [selectedDetalles, setSelectedDetalles] = useState([]);
    const [openTomaMuestra, setOpenTomaMuestra] = useState(false);
    const [selectedAnalisisIdForToma, setSelectedAnalisisIdForToma] = useState(null); const [openComentarioEntrega, setOpenComentarioEntrega] = useState(false);
    const [comentariosEntrega, setComentariosEntrega] = useState([]);

    // PDF Preview Modal states
    const [openPdfPreview, setOpenPdfPreview] = useState(false);
    const [pendingValidationAction, setPendingValidationAction] = useState(null);    // Reimprimir PDF states
    const [openReimprimirPreview, setOpenReimprimirPreview] = useState(false);
    const [reimprimirPdfUrl, setReimprimirPdfUrl] = useState(null);
    const [reimprimirLoading, setReimprimirLoading] = useState(false);
    const [reimprimirError, setReimprimirError] = useState(null);

    // Sobre Preview Modal states
    const [openSobrePreview, setOpenSobrePreview] = useState(false);

    // Estados para modal de preview de etiquetas
    const [openEtiquetasPreview, setOpenEtiquetasPreview] = useState(false);
    const [etiquetasPdfUrl, setEtiquetasPdfUrl] = useState(null);

    // Estados para modal de preview de orden
    const [openOrdenPreview, setOpenOrdenPreview] = useState(false);
    const [ordenPdfUrl, setOrdenPdfUrl] = useState(null);

    // Label Selection Modal states
    const [openLabelModal, setOpenLabelModal] = useState(false);
    const [availableSamples, setAvailableSamples] = useState([]);
    const [selectedSamples, setSelectedSamples] = useState([]);

    // Variable para determinar si la orden está en estado "Atendida" (modificacion: 4)
    // En este estado, los resultados están listos y la orden no debe ser modificable
    // NOTA: Los checkboxes de selección y botones de impresión permanecen habilitados
    // para permitir seleccionar e imprimir análisis específicos incluso cuando la orden está atendida
    const isOrdenAtendida = selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4;

    // Estados para el estado de facturación
    const [facturacionStatus, setFacturacionStatus] = useState({});

    const [multiSelectMode, setMultiSelectMode] = useState(false);
    const [selectedMultipleOrdenes, setSelectedMultipleOrdenes] = useState([]);

    const [comentariosEntregaPorOrden, setComentariosEntregaPorOrden] = useState([]);

    // Estados para el filtro de módulos en detalles
    const [selectedModuloDetalle, setSelectedModuloDetalle] = useState(
        localStorage.getItem('selectedModuloDetalle') ? 
        JSON.parse(localStorage.getItem('selectedModuloDetalle')) : null
    );
    const [modulosDetalles, setModulosDetalles] = useState([]);

    const [facturaPagada, setFacturaPagada] = useState(true);
    const [motivoBloqueo, setMotivoBloqueo] = useState("");
    const [verificandoPago, setVerificandoPago] = useState(false);

    // Estados para modal de Reprocesar Análisis
    const [openReprocesarModal, setOpenReprocesarModal] = useState(false);
    const [motivosReproceso, setMotivosReproceso] = useState([]);
    const [motivoReprocesoSeleccionado, setMotivoReprocesoSeleccionado] = useState('');
    const [primerResultado, setPrimerResultado] = useState('');
    const [confirmacionResultado, setConfirmacionResultado] = useState('');
    const [procesandoReproceso, setProcesandoReproceso] = useState(false);
    const [cargandoMotivosReproceso, setCargandoMotivosReproceso] = useState(false);
    const [estadosTomaDisponibles, setEstadosTomaDisponibles] = useState([]);

    // Función para determinar si se puede prevalidar un detalle
    const puedePrevalidar = (detalle) => {
        // Solo puede prevalidar si está en estado 1 "Sin Pre Validar" (tiene resultados ingresados)
        // Los detalles sin estado (vacío) no pueden prevalidarse
        return detalle && detalle.idTipoAprobacion === 1;
    };

    // Función para determinar si se puede validar un detalle  
    const puedeValidar = (detalle) => {
        return detalle && detalle.idTipoAprobacion === 2; // Solo "Pre Valido"
    };

    // Función para determinar si se puede invalidar un detalle
    const puedeInvalidar = (detalle) => {
        return detalle && detalle.idTipoAprobacion === 3; // Solo "Valido"
    };

    // Función para determinar si se puede quitar prevalidación
    const puedeQuitarPrevalidacion = (detalle) => {
        return detalle && detalle.idTipoAprobacion === 2; // Solo "Pre Valido"
    };

    // Funciones para verificar estado de múltiples detalles seleccionados
    const todosLosSeleccionadosPuedenPrevalidar = () => {
        return selectedDetalles.length > 0 && selectedDetalles.every(detalle => puedePrevalidar(detalle));
    };

    const todosLosSeleccionadosPuedenValidar = () => {
        return selectedDetalles.length > 0 && selectedDetalles.every(detalle => puedeValidar(detalle));
    };

    const todosLosSeleccionadosPuedenInvalidar = () => {
        return selectedDetalles.length > 0 && selectedDetalles.every(detalle => puedeInvalidar(detalle));
    };

    const todosLosSeleccionadosPuedenQuitarPrevalidacion = () => {
        return selectedDetalles.length > 0 && selectedDetalles.every(detalle => puedeQuitarPrevalidacion(detalle));
    };

    // Estados para el ordenamiento
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('asc');

    const toggleMultiSelectMode = () => {
        setMultiSelectMode(ms => {
            if (ms) setSelectedMultipleOrdenes([]);
            return !ms;
        });
    };

    // Función para manejar el ordenamiento
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // Función para comparar valores en el ordenamiento
    const descendingComparator = (a, b, orderBy) => {
        let valueA = a[orderBy];
        let valueB = b[orderBy];

        // Manejar fechas
        if (orderBy.includes('fecha') || orderBy.includes('Fecha')) {
            valueA = new Date(valueA);
            valueB = new Date(valueB);
        }
        // Manejar números
        else if (typeof valueA === 'string' && !isNaN(valueA)) {
            valueA = parseFloat(valueA) || 0;
            valueB = parseFloat(valueB) || 0;
        }
        // Manejar strings (case insensitive)
        else if (typeof valueA === 'string' && typeof valueB === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
        }

        if (valueB < valueA) {
            return -1;
        }
        if (valueB > valueA) {
            return 1;
        }
        return 0;
    };

    const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    // useEffect para obtener los módulos (ejemplo: módulos de tipo 1)
    useEffect(() => {
        const fetchModulos = async () => {
            try {
                const response = await fetch(`${server}/MgModuloes/porIdTipo/1`);
                if (response.ok) {
                    const data = await response.json();
                    setModulos(data.$values || []);
                    console.log(data.$values);
                } else {
                    console.error("Error al obtener modulos");
                }
            } catch (error) {
                console.error("Error al obtener modulos:", error);
            }
        };
        fetchModulos();
    }, [server]);

    // ✅ Inicializar sucursalFiltro con la sucursal de sesión cuando se carga la pantalla
    useEffect(() => {
        if (sucursalSeleccionada && !sucursalFiltro) {
            setSucursalFiltro(sucursalSeleccionada);
        }
    }, [sucursalSeleccionada]);

    useEffect(() => {
        if (sucursalFiltro && fechaInicio && fechaFin) {
            setPage(0);
            setCurrentPage(1);
            fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin, 1, false);
        }
    }, [sucursalFiltro, fechaInicio, fechaFin]);

    // ✅ Actualizar el objeto completo de sucursalFiltro cuando se cargan las sucursales
    useEffect(() => {
        if (sucursalFiltro && sucursales.length > 0) {
            const encontrada = sucursales.find(s => s.idSucursal === sucursalFiltro.idSucursal);
            if (encontrada && !sucursalFiltro.abreviatura) {
                setSucursalFiltro(encontrada); // ahora sí, objeto completo con abreviatura
            }
        }
    }, [sucursales]);

        useEffect(() => {
    if (!selectedOrdenTrabajo) return;

    setFacturaPagada(false);
    setMotivoBloqueo("");
    setVerificandoPago(true);

    fetch(`${server}/EnviarExamenes/EstadoPagoFactura/${selectedOrdenTrabajo.idOrdenMedica}`)
        .then(res => res.json())
        .then(data => {
            setFacturaPagada(data.pagada);
            setMotivoBloqueo(data.motivo || "");
        })
        .catch(() => {
            setFacturaPagada(false);
            setMotivoBloqueo("No se pudo verificar el estado de pago.");
        })
        .finally(() => {
            setVerificandoPago(false);
        });
    }, [selectedOrdenTrabajo]);



    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    // Función para cargar motivos de reproceso
    const fetchMotivosReproceso = async () => {
        setCargandoMotivosReproceso(true);
        try {
            const response = await fetch(`${server}/CdmCondicionesEspeciales/dereproceso`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${key}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                let condicionesArray = [];
                if (data && data.$values && Array.isArray(data.$values)) {
                    condicionesArray = data.$values;
                } else if (Array.isArray(data)) {
                    condicionesArray = data;
                }
                const condicionesLimpias = condicionesArray.map(condicion => ({
                    id: condicion.IdCondicion || condicion.idCondicion || condicion.id,
                    descripcion: condicion.DescripcionCondicion || condicion.descripcionCondicion || condicion.descripcion || 'Sin descripción'
                }));
                setMotivosReproceso(condicionesLimpias);
            } else {
                setMotivosReproceso([]);
            }
        } catch (error) {
            console.error('Error al obtener motivos de reproceso:', error);
            setMotivosReproceso([]);
        } finally {
            setCargandoMotivosReproceso(false);
        }
    };

    // Función para cargar estados de toma de muestra
    const fetchEstadosTomaDisponibles = async () => {
        try {
            const response = await fetch(`${server}/mg_estados_toma_muestras`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': key,
                },
            });
            if (response.ok) {
                const estadosData = await response.json();
                const estadosArray = estadosData.$values || estadosData;
                if (Array.isArray(estadosArray)) {
                    setEstadosTomaDisponibles(estadosArray);
                }
            }
        } catch (error) {
            console.error('Error al obtener estados de toma:', error);
        }
    };

    // Función para manejar el botón Reprocesar
    const handleReprocesar = async () => {
        if (!selectedOrdenTrabajo) {
            Swal.fire({ text: 'Primero debes seleccionar una orden de trabajo.', icon: 'warning' });
            return;
        }
        if (selectedDetalles.length === 0) {
            Swal.fire({ text: 'Selecciona al menos un análisis para reprocesar.', icon: 'warning' });
            return;
        }
        // Cargar motivos y estados
        await Promise.all([fetchMotivosReproceso(), fetchEstadosTomaDisponibles()]);
        setMotivoReprocesoSeleccionado('');
        setPrimerResultado('');
        setConfirmacionResultado('');
        setOpenReprocesarModal(true);
    };

    // Función para confirmar el reproceso
    const handleConfirmReproceso = async () => {
        if (!motivoReprocesoSeleccionado) {
            Swal.fire('Error', 'Debe seleccionar un motivo de reproceso', 'error');
            return;
        }
        if (!primerResultado.trim()) {
            Swal.fire('Error', 'Debe ingresar el primer resultado', 'error');
            return;
        }
        if (!confirmacionResultado.trim()) {
            Swal.fire('Error', 'Debe ingresar el resultado de confirmación', 'error');
            return;
        }

        setProcesandoReproceso(true);
        try {
            // Buscar el estado "Análisis Reprocesado" dinámicamente
            const estadoReprocesado = estadosTomaDisponibles.find(e => 
                e.estado === 'Análisis Reprocesado' || e.estado === 'Analisis Reprocesado'
            );
            if (!estadoReprocesado) {
                throw new Error('No se encontró el estado "Análisis Reprocesado" en la configuración de estados.');
            }

            const motivoSeleccionado = motivosReproceso.find(m => m.id === parseInt(motivoReprocesoSeleccionado));
            const motivoTexto = motivoSeleccionado ? motivoSeleccionado.descripcion : 'Motivo no especificado';
            const observacion = `MOTIVO REPROCESO: ${motivoTexto}\nReproceso: El primer resultado: ${primerResultado.trim()} y Resultados confirmacion: ${confirmacionResultado.trim()}`;

            const usuarioFormateado = user ? user.codigoUsuario : 'ADMIN';
            let exitosas = 0;
            let fallidas = 0;
            const errores = [];

            // Obtener las muestras de la orden directamente desde la API
            const responseMuestras = await fetch(`${server}/mg_muestras_x_ordens/pororden/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': key,
                },
            });

            if (!responseMuestras.ok) {
                throw new Error('No se pudieron obtener las muestras de la orden');
            }

            const muestrasData = await responseMuestras.json();
            const muestrasArray = muestrasData.$values || muestrasData || [];

            // Para cada análisis seleccionado, buscar su muestra por nombre de análisis
            for (const detalle of selectedDetalles) {
                try {
                    const muestrasDelAnalisis = muestrasArray.filter(m => {
                        const nombreMuestra = (m.analisis || '').trim().toLowerCase();
                        const nombreDetalle = (detalle.descripcionTipoAnalisis || '').trim().toLowerCase();
                        return nombreMuestra === nombreDetalle;
                    });

                    if (muestrasDelAnalisis.length > 0) {
                        for (const muestra of muestrasDelAnalisis) {
                            const requestData = {
                                IdOrden: selectedOrdenTrabajo.idOrdenMedica,
                                IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
                                EstadoAnterior: muestra.idEstado || 1,
                                NuevoEstado: estadoReprocesado.id,
                                UsuarioId: usuarioFormateado,
                                Comentario: observacion,
                                IdSucursal: sucursalSeleccionada?.idSucursal || null,
                                Cubiculo: null
                            };

                            const response = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-api-key': key,
                                },
                                body: JSON.stringify(requestData)
                            });

                            if (!response.ok) {
                                const errorText = await response.text();
                                throw new Error(errorText);
                            }
                        }
                        exitosas++;
                    } else {
                        errores.push(`${detalle.descripcionTipoAnalisis}: No tiene muestras tomadas`);
                        fallidas++;
                    }
                } catch (error) {
                    fallidas++;
                    errores.push(`${detalle.descripcionTipoAnalisis}: ${error.message}`);
                }
            }

            setOpenReprocesarModal(false);
            
            if (exitosas > 0) {
                Swal.fire({
                    title: 'Reproceso completado',
                    text: `${exitosas} análisis reprocesado(s) correctamente${fallidas > 0 ? `. ${fallidas} fallido(s).` : '.'}`,
                    icon: fallidas > 0 ? 'warning' : 'success',
                    timer: 3000,
                    showConfirmButton: fallidas > 0
                });
            } else {
                Swal.fire('Error', `No se pudo reprocesar ningún análisis.\n${errores.join('\n')}`, 'error');
            }

            // Refrescar detalles
            if (selectedOrdenTrabajo) {
                handleSelectOrdenTrabajo(selectedOrdenTrabajo);
            }
        } catch (error) {
            console.error('Error al reprocesar:', error);
            Swal.fire('Error', error.message, 'error');
        } finally {
            setProcesandoReproceso(false);
        }
    };

    // Función para cargar ordenes de trabajo desde la API with paginación y búsqueda
    // --- OBTENER ORDENES DE TRABAJO ---
    // Podrás pasar manualmente fechaInicio y fechaFin para la primera carga
    const fetchOrdenesTrabajos = async (
        search = '',
        fi = fechaInicio,
        ff = fechaFin,
        pageNum = 1,
        append = false
    ) => {
        try {
            if (pageNum === 1) {
                setLoading(true);
            } else {
                setLoadingMore(true);
            }

            const prevLength = append ? ordenesTrabajo.length : 0;

            const bodyData = {
                page: pageNum,
                limit: rowsPerPage,
                search,
                idSucursal: sucursalFiltro ? sucursalFiltro.idSucursal : 0, // ✅ Usar sucursalFiltro
                fechaInicio: fi,
                fechaFin: ff,
                idModulo: selectedModulo ? selectedModulo.idModulo : ""
            };
            console.log(bodyData);
            const response = await fetch(`${server}/MgOrdenesMedicas/Paginados`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData),
            });
            const data = await response.json();
            const ordenes = data.cotizaciones?.$values || data.cotizaciones || [];
            const totalFromBackend = data.total || data.Total || 0;

            const newTotalLoaded = prevLength + ordenes.length;

            if (append) {
                setOrdenesTrabajo(prev => [...prev, ...ordenes]);
            } else {
                setOrdenesTrabajo(ordenes);
            }

            setTotalOrdenesTrabajo(totalFromBackend);
            setCurrentPage(pageNum);
            setHasMore(newTotalLoaded < totalFromBackend);

            // Cargar estado de facturación en segundo plano
            if (ordenes.length > 0) {
                setTimeout(() => loadFacturacionStatus(ordenes), 0);
            }
        } catch (error) {
            console.error('Error al cargar las órdenes de trabajo:', error);
            if (!append) {
                setOrdenesTrabajo([]);
                setTotalOrdenesTrabajo(0);
            }
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const fetchComentariosEntrega = async (idOrdenMedica) => {
    try {
        const response = await fetch(
            `${server}/MgOrdenesMedicasComentariosEntregas/porOrden/${idOrdenMedica}`

        );

        if (!response.ok) {
            throw new Error('Error al obtener comentarios');
        }

        const data = await response.json();
        setComentariosEntregaPorOrden(data);
        console.log("COMENTARIOS", data)
    } catch (error) {
        console.error(error);
        setComentariosEntregaPorOrden([]);
    }
};


    // --- useEffect: Montaje ---
    useEffect(() => {
        const fetchDataInicial = async () => {
            try {
                const now = new Date();
                const startDate = new Date();
                startDate.setMonth(startDate.getMonth() - 3);
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                const defaultInicio = startDate.toISOString().split('T')[0];
                const defaultFin = tomorrow.toISOString().split('T')[0];

                // Cargar sucursales
                const response = await fetch(`${server}/MgSucursales`);
                const data = await response.json();
                const lista = data.$values || data;
                setSucursales(lista);

                // Establecer fechas
                setFechaInicio(defaultInicio);
                setFechaFin(defaultFin);

                // ✅ La sucursalFiltro se inicializa automáticamente desde el contexto en useEffect
            } catch (error) {
                console.error('Error al inicializar datos:', error);
            }
        };

        fetchDataInicial();
    }, []);

    // --- MANEJADORES SUCURSAL / FECHA / BUSCAR ---
    // ✅ SOLO actualiza el filtro local, NO modifica la sesión global
    const handleSucursalSeleccionada = (event, newValue) => {
        console.log('🔍 Cambio de filtro de sucursal (solo para esta pantalla):', newValue);
        setSucursalFiltro(newValue); // ✅ Solo cambia el filtro local
    };
    const handleFechaInicioChange = (e) => setFechaInicio(e.target.value);
    const handleFechaFinChange = (e) => setFechaFin(e.target.value);
    // Cargar más cotizaciones al cambiar de página
    // useEffect(() => {
    //     if (page * rowsPerPage >= ordenesTrabajo.length - rowsPerPage && hasMore && !isLoadingMore) {
    //         setIsLoadingMore(true);
    //         fetchOrdenesTrabajos(page, 100, searchQuery).then(() => setIsLoadingMore(false));
    //     }
    // }, [page]);    // Manejar cambio en el campo de búsqueda
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Manejar búsqueda al hacer clic en el botón
    const handleSearch = () => {
        setPage(0);
        setCurrentPage(1);
        fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin, 1, false);
    };

    // Manejar cambio de página
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        
        // Si estamos llegando al final de los datos cargados y hay más datos disponibles
        const isNearEnd = (newPage + 1) * rowsPerPage >= ordenesTrabajo.length;
        if (isNearEnd && hasMore && !loadingMore) {
            fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin, currentPage + 1, true);
        }
    };

    // Manejar cambio en el número de filas por página
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        setCurrentPage(1);
        // Recargar datos con el nuevo límite
        fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin, 1, false);
    };

    // Manejadores para la paginación de la tabla de detalles - ELIMINADOS PARA MOSTRAR TODOS LOS ANÁLISIS

    // Función para recargar los detalles de la orden seleccionada
    const recargarDetallesOrden = async () => {
        if (!selectedOrdenTrabajo) {
            console.log('No hay orden seleccionada para recargar');
            return;
        }

        console.log('🔄 Recargando detalles de la orden:', selectedOrdenTrabajo.idOrdenMedica);
        
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${selectedOrdenTrabajo.idOrdenMedica}`);
            if (response.ok) {
                const data = await response.json();
                const detallesFromAPI = data.$values || [];
                console.log('✅ Detalles recargados exitosamente:', detallesFromAPI.length, 'detalles');
                
                // Actualizar el estado de los detalles
                setDetallesOrdenTrabajo(detallesFromAPI);
                
                // Si había un detalle seleccionado, actualizarlo también
                if (detalleSeleccionado && detalleSeleccionado.idDetalle) {
                    const detalleActualizado = detallesFromAPI.find(d => d.idDetalle === detalleSeleccionado.idDetalle);
                    if (detalleActualizado) {
                        console.log('📝 Actualizando detalle seleccionado:', detalleActualizado);
                        setDetalleSeleccionado(detalleActualizado);
                    }
                }
            } else {
                console.error('❌ Error al recargar los detalles de la orden');
            }
        } catch (error) {
            console.error('❌ Error en la solicitud de recarga:', error);
        }
    };

    // Función para manejar el cierre del modal de resultados
    const handleCloseResultados = async () => {
        console.log('🚪 Cerrando modal de resultados y recargando detalles...');
        setOpenResultadosModal(false);
        
        // Recargar los detalles para reflejar cualquier cambio de estado
        await recargarDetallesOrden();
    };

    const handleSelectDetalle = (idDetalle) => {
        console.log(idDetalle);
        setDetalleSeleccionado(idDetalle);
    };


    // Manejar selección de una cotización
    const handleSelectOrdenTrabajo = async (ordenTrabajo) => {
        setSelectedOrdenTrabajo(ordenTrabajo);
        setDetalleSeleccionado(null);
        setSelectedDetalles([]);

        if (ordenTrabajo?.idOrdenMedica) {
            fetchComentariosEntrega(ordenTrabajo.idOrdenMedica);
        } else {
            setComentariosEntregaPorOrden([]);
        }

        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${ordenTrabajo.idOrdenMedica}`);
            if (response.ok) {
                const data = await response.json();
                const detallesFromAPI = data.$values || [];
                setDetallesOrdenTrabajo(detallesFromAPI);

                const modulosUnicos = [...new Set(detallesFromAPI
                    .filter(detalle => detalle.nombreModulo)
                    .map(detalle => detalle.nombreModulo)
                )].sort();
                setModulosDetalles(modulosUnicos);
            } else {
                console.error('Error al obtener los detalles de la orden de trabajo');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
        }
    };


    useEffect(() => {
    setSelectedDetalles(prev =>
        prev.map(sel => {
        const actualizado = detallesOrdenTrabajo.find(
            d => d.idDetalle === sel.idDetalle
        );
        return actualizado ?? sel;
        })
    );
    }, [detallesOrdenTrabajo]);


    // Función para seleccionar/deseleccionar todos los detalles
    const toggleSelectAllDetalles = () => {
        const todosSeleccionados = detallesFiltrados.length > 0 &&
            detallesFiltrados.every(detalle =>
                selectedDetalles.some(d => d.idDetalle === detalle.idDetalle)
            );

        if (todosSeleccionados) {
            // Si todos los filtrados están seleccionados, deseleccionar solo los filtrados
            const detallesNoFiltrados = selectedDetalles.filter(detalle => 
                !detallesFiltrados.some(df => df.idDetalle === detalle.idDetalle)
            );
            setSelectedDetalles(detallesNoFiltrados);
        } else {
            // Si no todos están seleccionados, agregar todos los filtrados a la selección
            const nuevosSeleccionados = [...selectedDetalles];
            detallesFiltrados.forEach(detalle => {
                if (!selectedDetalles.some(d => d.idDetalle === detalle.idDetalle)) {
                    nuevosSeleccionados.push(detalle);
                }
            });
            setSelectedDetalles(nuevosSeleccionados);
        }
    };

    // Filtrar detalles por módulo seleccionado
    const detallesFiltrados = useMemo(() => {
        if (!selectedModuloDetalle) {
            return detallesOrdenTrabajo;
        }
        return detallesOrdenTrabajo.filter(detalle => detalle.nombreModulo === selectedModuloDetalle);
    }, [detallesOrdenTrabajo, selectedModuloDetalle]);

    // Verificar si todos los detalles filtrados están seleccionados
    const todosDetallesSeleccionados = detallesFiltrados.length > 0 &&
        detallesFiltrados.every(detalle =>
            selectedDetalles.some(d => d.idDetalle === detalle.idDetalle)
        );

    // Verificar si algunos detalles están seleccionados (para estado indeterminado)
    const algunosDetallesSeleccionados = selectedDetalles.length > 0 && !todosDetallesSeleccionados;

    // Variable auxiliar para verificar si todos los detalles filtrados están seleccionados
    const allSelected = selectedDetalles.length === detallesFiltrados.length && detallesFiltrados.length > 0;

    // Verificar si los análisis seleccionados están todos validados (para habilitar botones de envío)
    const haySeleccionados = selectedDetalles.length > 0;
    const todosSeleccionadosValidados = haySeleccionados && selectedDetalles.every(d => d.idTipoAprobacion === 3);
    const puedeEnviarResultados = haySeleccionados && todosSeleccionadosValidados;
    const tooltipEnvio = !haySeleccionados
        ? 'No hay análisis seleccionados'
        : !todosSeleccionadosValidados
            ? 'No todos los análisis seleccionados están validados'
            : '';

    // Función para manejar el cambio de módulo en el filtro de detalles
    const handleModuloDetalleChange = (event, newValue) => {
        setSelectedModuloDetalle(newValue);
        // Guardar la selección en localStorage
        if (newValue) {
            localStorage.setItem('selectedModuloDetalle', JSON.stringify(newValue));
        } else {
            localStorage.removeItem('selectedModuloDetalle');
        }
        // Limpiar selecciones de detalles al cambiar filtro
        setSelectedDetalles([]);
    };

    // --- MANEJADORES DE ACCIONES ---
    const handleFactura = async () => {
        // 1) Verifico caja abierta
        // if (!cajaAbierta) {
        //     swalWithHighZIndex.fire({
        //         title: 'Error',
        //         text: 'No hay caja abierta. Por favor, inicie la caja antes de facturar.',
        //         icon: 'error',
        //         zIndex: 2000
        //     });
        //     return;
        // }

        // 2) Modo múltiple
        if (multiSelectMode) {
            if (selectedMultipleOrdenes.length === 0) {
                Swal.fire({
                    text: 'Debes seleccionar al menos una orden de trabajo',
                    icon: 'warning'
                });
                return;
            }

            const ordenes = selectedMultipleOrdenes.map(o => ({
                ordenTrabajo: o.idOrdenMedica,
                nombreCliente: o.nombreCompleto,
                identidad: o.Identidad,
                valorPagar: o.valorVenta - o.valorDescuento,
                valorVenta: o.valorVenta,
                valorDescuento: o.valorDescuento,
                idSucursal: o.idSucursal,
                idCliente: o.idCliente
            }));

            console.log('ordenes', ordenes);

            setFacturaData({ multiple: true, ordenes });
            setOpenFacturaModal(true);
            return;
        }

        // 3) Modo simple
        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Debes seleccionar una orden de trabajo',
                icon: 'warning'
            });
            return;
        }

        try {
            setFacturaData({
                multiple: false,
                ordenTrabajo: selectedOrdenTrabajo.idOrdenMedica,
                nombreCliente: selectedOrdenTrabajo.nombreCompleto,
                identidad: selectedOrdenTrabajo.Identidad,
                valorVenta: selectedOrdenTrabajo.valorVenta,
                valorDescuento: selectedOrdenTrabajo.valorDescuento,
                idSucursal: selectedOrdenTrabajo.idSucursal,
                idCliente: selectedOrdenTrabajo.idCliente
            });

            console.log('FACTURA>preparando modal', {
                idOrdenMedica: selectedOrdenTrabajo.idOrdenMedica,
                valorVenta: selectedOrdenTrabajo.valorVenta,
                valorDescuento: selectedOrdenTrabajo.valorDescuento,
                valorPagar: selectedOrdenTrabajo.valorVenta - selectedOrdenTrabajo.valorDescuento,
            });

            setOpenFacturaModal(true);
        } catch (error) {
            console.error('Error al preparar la factura:', error);
            Swal.fire({
                text: 'Error inesperado al preparar la factura',
                icon: 'error'
            });
        }
    };


    // Función para agrupar muestras por descripción, módulo y cantidad (EXACTAMENTE como TomaMuestra)
    const agruparMuestrasParaEtiquetas = (muestrasData) => {
        const muestrasAgrupadas = new Map();
        
        muestrasData.forEach((muestra, index) => {
            // Crear una clave única para agrupar por módulo, descripción de muestra y cantidad
            const clave = `${muestra.descripcionMuestra}-${muestra.modulo}-${muestra.descripcionCantidad}`;
            
            if (muestrasAgrupadas.has(clave)) {
                // Si ya existe, agregar el análisis a la lista
                const muestraExistente = muestrasAgrupadas.get(clave);
                muestraExistente.analisis.push(muestra.ComparteCon);
                muestraExistente.examenes.push(muestra);
            } else {
                // Crear nueva entrada agrupada
                muestrasAgrupadas.set(clave, {
                    idMuestraXAnalisis: muestra.idMuestraXAnalisis,
                    modulo: muestra.modulo || 'N/A',
                    descripcionMuestra: muestra.descripcionMuestra,
                    descripcionCantidad: muestra.descripcionCantidad,
                    observaciones: muestra.observaciones,
                    analisis: [muestra.ComparteCon],
                    examenes: [muestra],
                    ComparteCon: muestra.ComparteCon,
                    esCobas303: muestra.esCobas303 || false,
                    cantidadMuestras: 1
                });
            }
        });
        
        // Convertir el Map a array y formatear ComparteCon
        const resultado = Array.from(muestrasAgrupadas.values()).map(muestra => ({
            ...muestra,
            ComparteCon: muestra.analisis.join(', '),
            cantidadMuestras: muestra.examenes.length
        }));
        
        return resultado;
    };

    const handleImprimirEtiquetas = async () => {
        if (selectedOrdenTrabajo.idOrdenMedica) {
            try {
                // ✅ USAR LA MISMA API QUE TomaMuestra (con filtrado del backend)
                const response = await fetch(`${server}/mg_muestras_x_ordens/pororden/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': key,
                    },
                });
                
                if (response.ok) {
                    const muestrasData = await response.json();

                    // Detectar si es sucursal principal (ID = 2)
                    const esSucursalPrincipal = sucursalFiltro?.idSucursal === 2;
                    
                    // Procesar muestras desde el nuevo endpoint
                    const samples = [];
                    const muestrasArray = muestrasData.$values || muestrasData;
                    
                    muestrasArray.forEach(muestra => {
                        // Pre-seleccionar COBAS si es sucursal principal Y módulo es bioquímica clínica
                        const moduloTexto = (muestra.modulo || '').toLowerCase();
                        const esBioquimicaClinica = moduloTexto.includes('bioquimica') || 
                                                    moduloTexto.includes('bioquímica') ||
                                                    (moduloTexto.includes('bio') && moduloTexto.includes('clinica'));
                        
                        const preSeleccionarCobas = esSucursalPrincipal && esBioquimicaClinica;
                        
                        samples.push({
                            idMuestraXAnalisis: muestra.idMuestraXAnalisis,
                            modulo: muestra.modulo || 'N/A',
                            descripcionMuestra: muestra.descripcionMuestra,
                            descripcionCantidad: muestra.cantidad,
                            observaciones: muestra.observaciones,
                            ComparteCon: muestra.analisis,
                            esCobas303: preSeleccionarCobas || false,
                            idEstado: muestra.idEstado || 1,
                            estadoDescripcion: muestra.estadoDescripcion || 'Pendiente'
                        });
                    });

                    if (samples.length === 0) {
                        Swal.fire({
                            title: 'Sin muestras',
                            text: 'No se encontraron muestras para esta orden.',
                            icon: 'info'
                        });
                        return;
                    }

                    // Agrupar muestras igual que TomaMuestra
                    const muestrasAgrupadas = agruparMuestrasParaEtiquetas(samples);
                    
                    setAvailableSamples(muestrasAgrupadas);
                    setSelectedSamples([]);
                    setOpenLabelModal(true);
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || 'Error al obtener los datos de la orden';
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al obtener muestras',
                    text: error.message || 'Ocurrió un error inesperado',
                });
            }
        } else {
            Swal.fire({
                text: 'No hay orden seleccionada para imprimir etiquetas.',
                icon: 'warning'
            });
        }
    };


    // Label Modal Helper Functions
    const handleCloseLabelModal = () => {
        setOpenLabelModal(false);
        setSelectedSamples([]);
        setAvailableSamples([]);
    };

    const handleSampleSelectionChange = (muestraAgrupada, checked) => {
        if (checked) {
            // Agregar solo el ID principal del grupo (como TomaMuestra)
            setSelectedSamples(prev => [...prev, muestraAgrupada.idMuestraXAnalisis]);
        } else {
            // Quitar el ID principal del grupo
            setSelectedSamples(prev => prev.filter(id => id !== muestraAgrupada.idMuestraXAnalisis));
        }
    };

    const handleSelectAllSamples = (checked) => {
        if (checked) {
            // Recoger solo los IDs principales de cada grupo (como TomaMuestra)
            const todosLosIds = availableSamples.map(muestra => muestra.idMuestraXAnalisis);
            setSelectedSamples(todosLosIds);
        } else {
            setSelectedSamples([]);
        }
    };

    const handlePrintSelectedLabels = async () => {
        if (selectedSamples.length === 0) {
            Swal.fire({
                title: 'Seleccione muestras',
                text: 'Debe seleccionar al menos una muestra para imprimir etiquetas',
                icon: 'warning'
            });
            return;
        }

        try {
            const idOrden = selectedOrdenTrabajo.idOrdenMedica;

            // Crear el array de objetos con la estructura esperada por el backend - EXACTAMENTE como TomaMuestra
            const muestrasSeleccionadasRequest = selectedSamples.map(idMuestra => {
                const muestra = availableSamples.find(m => m.idMuestraXAnalisis === idMuestra);
                return {
                    IdMuestraXAnalisis: idMuestra,
                    EsCobas303: muestra?.esCobas303 || false
                };
            });

            const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirEtiquetasSeleccionadas/${idOrden}?anchoMM=60&altoMM=30`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(muestrasSeleccionadasRequest)
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                
                // Mostrar el PDF en una ventana emergente (modal)
                setEtiquetasPdfUrl(url);
                setOpenEtiquetasPreview(true);
                handleCloseLabelModal();
                
                Swal.fire({
                    title: 'Éxito',
                    text: 'Las etiquetas se han generado correctamente',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || 'Error al generar las etiquetas';
                Swal.fire({
                    title: 'Error',
                    text: errorMessage,
                    icon: 'error'
                });
            }
        } catch (error) {
            console.error('Error al imprimir etiquetas:', error);
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al generar las etiquetas',
                icon: 'error'
            });
        }
    }
    // Acciones con la cotización seleccionada
    const handleImprimir = async () => {
        if (selectedOrdenTrabajo) {
            try {
                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'POST',
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    
                    // Mostrar el PDF en una ventana emergente (modal)
                    setOrdenPdfUrl(url);
                    setOpenOrdenPreview(true);
                    
                    Swal.fire({
                        title: 'Éxito',
                        text: 'La orden se ha generado correctamente',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                } else {
                    console.error('Error al imprimir la orden de trabajo');
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un error al imprimir la orden de trabajo.',
                        icon: 'error'
                    });
                }
            } catch (error) {
                console.error('Error al imprimir la orden de trabajo:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Hubo un error al imprimir la orden de trabajo.',
                    icon: 'error'
                });
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    }; const handleImprimirSobre = async () => {
        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        // Open the preview modal
        setOpenSobrePreview(true);
    };


    const handleVerCompleto = async () => {
        if (selectedOrdenTrabajo) {
            try {
                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'POST',
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    console.error('Error al imprimir la orden de trabajo');
                    alert('Hubo un error al imprimir la orden de trabajo.');
                }
            } catch (error) {
                console.error('Error al imprimir la orden de trabajo:', error);
                alert('Hubo un error al imprimir la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };

    const formatWhatsappNumber = (telefono) => {
    if (!telefono) return '';
    // Elimina espacios, guiones y paréntesis
    let cleaned = telefono.replace(/[\s\-()]/g, '');
    // Si ya empieza con +504, lo deja igual
    if (cleaned.startsWith('+504')) return cleaned;
    // Si empieza con 504 sin +, lo agrega
    if (cleaned.startsWith('504')) return '+504' + cleaned.slice(3);
    // Si solo es el número, lo agrega
    if (cleaned.length === 8) return '+504' + cleaned;
    // Si ya tiene + y otro país, lo deja igual
    if (cleaned.startsWith('+')) return cleaned;
    // Por defecto, retorna como está
    return cleaned;
};

const formatoFecha = (fecha) => {
  return fecha ? new Date(fecha).toLocaleString('es-PE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }) : '';
};

const fechaActualLocalISO = () => {
  const now = new Date();
  const tzOffset = now.getTimezoneOffset() * 60000; // offset en ms
  const localDate = new Date(now - tzOffset);       // ajusta a hora local
  return localDate.toISOString().slice(0, 19);      // "YYYY-MM-DDTHH:MM:SS"
};

    const handleWhatsapp = async () => {
        if (selectedOrdenTrabajo) {
            // Opciones para el usuario
            const { value: opcion } = await Swal.fire({
                title: 'Enviar por WhatsApp',
                input: 'radio',
                inputOptions: {
                    'resultados': 'Resultados Validados',
                    'factura': 'Factura'
                },
                inputValue: 'resultados', // Opción predeterminada
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar'
            });

            if (!opcion) {
                return; // El usuario canceló
            }

              if (!facturaPagada) {
                Swal.fire({
                icon: 'warning',
                title: 'Factura pendiente',
                text: motivoBloqueo || 'La factura no está totalmente pagada.',
                });
             return;
            }


            // Solicitar número de WhatsApp
            const { value: numeroWhatsapp } = await Swal.fire({
                title: 'Ingrese el número de WhatsApp',
                input: 'text',
                inputLabel: 'Número de WhatsApp',
                inputPlaceholder: '+50433333333',
                inputValue: formatWhatsappNumber(selectedOrdenTrabajo.telefono || ''),
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Por favor ingrese un número de WhatsApp';
                    }
                    // Validar que el número de WhatsApp tenga un formato adecuado
                    const whatsappRegex = /^\+?[0-9]{1,4}[0-9]{10,15}$/;
                    if (!whatsappRegex.test(value)) {
                        return 'Por favor ingrese un número de WhatsApp válido, incluyendo el código de área si es necesario';
                    }
                }
            });

            if (numeroWhatsapp) {
                try {
                    let response;

                    if (opcion === 'resultados') {
                        // Usar solo los análisis seleccionados por el usuario
                        if (selectedDetalles.length === 0) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Sin análisis seleccionados',
                                text: 'Por favor seleccione los análisis que desea enviar.',
                            });
                            return;
                        }

                        // Verificar que todos los seleccionados estén validados
                        const noValidados = selectedDetalles.filter(d => d.idTipoAprobacion !== 3);
                        if (noValidados.length > 0) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Análisis no validados',
                                text: 'Todos los análisis seleccionados deben estar validados para poder enviarlos.',
                            });
                            return;
                        }

                        // Extraer solo los IDs de los exámenes seleccionados (ya validados)
                        const idExamenes = selectedDetalles.map(detalle => detalle.idDetalle);
                        console.log('Exámenes seleccionados para enviar:', idExamenes);
                        // Enviar resultados validados - usando el endpoint especificado
                        response = await fetch(`${server}/EnviarExamenes/EnviarExamenes`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                idExamenes: idExamenes,
                                numeroWhatsapp: numeroWhatsapp
                            })
                        });
                    } else if (opcion === 'factura') {
                        // Obtenemos todas las facturas asociadas a la orden de trabajo
                        const facturasResponse = await fetch(`${server}/FtFacturas/facturasbyorden/${selectedOrdenTrabajo.idOrdenMedica}`);

                        if (!facturasResponse.ok) {
                            throw new Error('Error al obtener facturas asociadas a esta orden de trabajo');
                        }

                        let facturasData = await facturasResponse.json();
                        // Manejar diferentes formatos de respuesta (array o objeto con $values)
                        let facturas = [];
                        if (facturasData && facturasData.$values && Array.isArray(facturasData.$values)) {
                            facturas = facturasData.$values;
                        } else if (Array.isArray(facturasData)) {
                            facturas = facturasData;
                        }

                        if (facturas.length === 0) {
                            throw new Error('Esta orden no tiene facturas asociadas');
                        }

                        // Si hay múltiples facturas, preguntar al usuario cuál enviar
                        let selectedFactura;
                        if (facturas.length === 1) {
                            // Si solo hay una factura, seleccionarla automáticamente
                            selectedFactura = facturas[0];
                        } else {
                            // Si hay múltiples facturas, mostrar diálogo para seleccionar
                            const { value: facturaIndex } = await Swal.fire({
                                title: 'Seleccione la factura a enviar',
                                input: 'radio',
                                inputOptions: facturas.reduce((options, factura, index) => {
                                    options[index] = `Factura #${factura.numeroFactura || 'Sin número'} - L. ${factura.valorFactura || 0}`;
                                    return options;
                                }, {}),
                                showCancelButton: true,
                                inputValidator: (value) => {
                                    if (!value) {
                                        return 'Debe seleccionar una factura';
                                    }
                                }
                            });

                            if (facturaIndex === undefined) {
                                return; // Usuario canceló la selección
                            }

                            selectedFactura = facturas[facturaIndex];
                        }

                        // Enviar la factura seleccionada por WhatsApp
                        response = await fetch(`${server}/Whatsapp/PostFacturaWhatsapp?idFactura=${selectedFactura.idFactura}&numeroWhatsapp=${numeroWhatsapp}`, {
                            method: 'POST',
                        });
                    }

                    if (response.ok) {
                        Swal.fire({
                            icon: 'success',
                            title: 'WhatsApp Enviado',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    } else {
                        let errorMessage = 'Ocurrió un error inesperado';
                        try {
                            const errorData = await response.text();
                            // Intenta parsear como JSON solo si parece JSON válido
                            if (errorData && errorData.trim().startsWith('{')) {
                                const jsonData = JSON.parse(errorData);
                                errorMessage = jsonData.message || (jsonData.errors ? Object.values(jsonData.errors).flat().join(', ') : errorMessage);
                            } else {
                                errorMessage = errorData || `Error ${response.status}: No se pudo procesar la respuesta`;
                            }
                        } catch (parseError) {
                            console.error('Error al procesar la respuesta:', parseError);
                            errorMessage = `Error ${response.status}: No se pudo procesar la respuesta`;
                        }

                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al enviar el WhatsApp',
                        text: error.message || 'Ocurrió un error inesperado',
                    });
                }
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };

    // Método para enviar correo electrónico con la orden de trabajo
    const handleEnviarCorreo = async () => {
        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Opciones para el usuario
            const { value: opcion } = await Swal.fire({
                title: 'Enviar por correo electrónico',
                input: 'radio',
                inputOptions: {
                    'resultados': 'Resultados Validados',
                    'factura': 'Factura'
                },
                inputValue: 'resultados', // Opción predeterminada
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar'
            });

            if (!opcion) {
                return; // El usuario canceló
            }

            if (!facturaPagada) {
                Swal.fire({
                icon: 'warning',
                title: 'Factura pendiente',
                text: motivoBloqueo || 'La factura no está totalmente pagada.',
                });
             return;
            }


            // Pequeño retraso para asegurar que cualquier modal anterior se cierre completamente
            await new Promise(resolve => setTimeout(resolve, 100));
            
            const { value: email } = await Swal.fire({
                title: 'Enviar por correo electrónico',
                input: 'email',
                inputLabel: 'Dirección de correo electrónico',
                inputPlaceholder: 'Ingrese el correo electrónico',
                inputValue: selectedOrdenTrabajo.correoElectronico || '',
                showCancelButton: true,
                allowOutsideClick: false,
                heightAuto: true,
                focusConfirm: false,
                inputAutoFocus: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Por favor ingrese una dirección de correo válida';
                    }
                }
            });

            if (email) {
                let response;
                
                if (opcion === 'resultados') {
                    // Usar solo los análisis seleccionados por el usuario
                    if (selectedDetalles.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Sin análisis seleccionados',
                            text: 'Por favor seleccione los análisis que desea enviar.',
                        });
                        return;
                    }

                    // Verificar que todos los seleccionados estén validados
                    const noValidados = selectedDetalles.filter(d => d.idTipoAprobacion !== 3);
                    if (noValidados.length > 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Análisis no validados',
                            text: 'Todos los análisis seleccionados deben estar validados para poder enviarlos.',
                        });
                        return;
                    }

                    // Extraer solo los IDs de los exámenes seleccionados (ya validados)
                    const idExamenes = selectedDetalles.map(detalle => detalle.idDetalle);
                    
                    // Enviar resultados validados por correo
                    response = await fetch(`${server}/Correo/enviar-resultados`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            idExamenes: idExamenes,
                            correoElectronico: email,
                            asunto: 'Resultados de Laboratorio',
                            mensaje: `Estimado paciente, adjuntamos los resultados de sus análisis clínicos.`
                        })
                    });
                } 
                else if (opcion === 'factura') {
                    // Obtenemos todas las facturas asociadas a la orden de trabajo
                    const facturasResponse = await fetch(`${server}/FtFacturas/facturasbyorden/${selectedOrdenTrabajo.idOrdenMedica}`);

                    if (!facturasResponse.ok) {
                        throw new Error('Error al obtener facturas asociadas a esta orden de trabajo');
                    }

                    let facturasData = await facturasResponse.json();
                    // Manejar diferentes formatos de respuesta (array o objeto con $values)
                    let facturas = [];
                    if (facturasData && facturasData.$values && Array.isArray(facturasData.$values)) {
                        facturas = facturasData.$values;
                    } else if (Array.isArray(facturasData)) {
                        facturas = facturasData;
                    }

                    if (facturas.length === 0) {
                        throw new Error('Esta orden no tiene facturas asociadas');
                    }

                    // Si hay múltiples facturas, preguntar al usuario cuál enviar
                    let selectedFactura;
                    if (facturas.length === 1) {
                        // Si solo hay una factura, seleccionarla automáticamente
                        selectedFactura = facturas[0];
                    } else {
                        // Si hay múltiples facturas, mostrar diálogo para seleccionar
                        const { value: facturaIndex } = await Swal.fire({
                            title: 'Seleccione la factura a enviar',
                            input: 'radio',
                            inputOptions: facturas.reduce((options, factura, index) => {
                                options[index] = `Factura #${factura.numeroFactura || 'Sin número'} - L. ${factura.valorFactura || 0}`;
                                return options;
                            }, {}),
                            showCancelButton: true,
                            inputValidator: (value) => {
                                if (!value) {
                                    return 'Debe seleccionar una factura';
                                }
                            }
                        });

                        if (facturaIndex === undefined) {
                            return; // Usuario canceló la selección
                        }

                        selectedFactura = facturas[facturaIndex];
                    }

                    // Enviar la factura seleccionada por correo
                    response = await fetch(`${server}/Correo/enviar-factura?idFactura=${selectedFactura.idFactura}&destinatario=${encodeURIComponent(email)}&asunto=Factura%20Laboratorio`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                }

                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Correo enviado',
                        text: 'El documento ha sido enviado por correo electrónico',
                        showConfirmButton: false,
                        timer: 1500
                    });
                } else {
                    let errorMessage = 'Ocurrió un error inesperado';
                    try {
                        const errorData = await response.text();
                        // Intenta parsear como JSON solo si parece JSON válido
                        if (errorData && errorData.trim().startsWith('{')) {
                            const jsonData = JSON.parse(errorData);
                            errorMessage = jsonData.message || (jsonData.errors ? Object.values(jsonData.errors).flat().join(', ') : errorMessage);
                        } else {
                            errorMessage = errorData || `Error ${response.status}: No se pudo procesar la respuesta`;
                        }
                    } catch (parseError) {
                        console.error('Error al procesar la respuesta:', parseError);
                        errorMessage = `Error ${response.status}: No se pudo procesar la respuesta`;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            }
        } catch (error) {
            console.error("Error al enviar correo:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'No se pudo enviar el correo'
            });
        }
    };
    
    const handleModificar = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        console.log(selectedOrdenTrabajo);
        if (selectedOrdenTrabajo) {
            try {
                // Paso 1: Obtener la cotización seleccionada
                const responseOrdenCompra = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`);
                const OrdenTrabajo = await responseOrdenCompra.json();

                console.log(OrdenTrabajo);

                // Paso 2: Obtener los detalles de la cotización (analisisAgregados)
                // const responseDetalles = await fetch(`${server}/CtzCotizacionesDetalles/porIdCotizacion/${selectedCotizacion.idCotizacion}`);
                // const detalles = await responseDetalles.json();

                // console.log(detalles.$values);
                // Paso 3: Preparar los datos para pasar al componente GestionCotizaciones
                setOrdenTrabajoData({
                    OrdenTrabajo: OrdenTrabajo,
                    modo: 'modificar',
                    // detalles: detalles.$values || [], // Asegurarse de que sea un array
                });

                // Paso 4: Abrir el modal
                setOpenModal(true);

            } catch (error) {
                console.error('Error al obtener la orden de trabajo:', error);
                alert('Hubo un error al obtener la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };


    const handleDividir = async () => {
        if (selectedOrdenTrabajo) {
            try {
                // Obtener los datos completos de la orden de trabajo seleccionada
                const responseOrdenTrabajo = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`);
                const ordenTrabajoData = await responseOrdenTrabajo.json();

                // Preparar los datos para pasar al componente GestionOrdenTrabajo
                setOrdenTrabajoData({
                    OrdenTrabajo: ordenTrabajoData,
                    modo: 'dividir', // Indicamos que estamos en modo "dividir"
                });

                // Abrir el modal
                setOpenModal(true);
            } catch (error) {
                console.error('Error al obtener la orden de trabajo:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un error al obtener la orden de trabajo.',
                });
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning',
            });
            return;
        }
    };


    const handleCrearOrden = () => {
        if (selectedOrdenTrabajo) {
            console.log('Crear orden de trabajo para la cotización:', selectedOrdenTrabajo);
            // Lógica para crear una orden de trabajo
        } else {
            alert('Por favor selecciona una cotización.');
        }
    };

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95vw',  // Aumentado de 60% a 85%
    height: '90vh', // Especificar altura
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: 24,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden' // Cambiado de overflowY: 'auto' para manejar el scroll en el iframe
};

const fullScreenModalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#fff',
    padding: '20px',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: 9999
};

    const paginatedOrdenesTrabajo = useMemo(() => {
        const sortedData = orderBy
            ? [...ordenesTrabajo].sort(getComparator(order, orderBy))
            : ordenesTrabajo;
        
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        return sortedData.slice(start, end);
    }, [ordenesTrabajo, order, orderBy, page, rowsPerPage]);
    // Funciones manejadoras
    const handlePrevalidar = () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        if (!detalleSeleccionado) {
            Swal.fire({
                text: 'Por favor selecciona un examen.',
                icon: 'warning'
            })
            return;
        }

        // Verificar si el detalle puede ser prevalidado
        if (!puedePrevalidar(detalleSeleccionado)) {
            Swal.fire({
                title: 'No se puede prevalidar',
                text: 'Este examen ya tiene una validación aplicada. Solo se pueden prevalidar exámenes sin validación previa.',
                icon: 'warning'
            });
            return;
        }

        // Show PDF preview before confirming prevalidation
        const confirmPrevalidation = () => {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Esta seguro de desea prevalidar este examen?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Prevalidar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarPrevalidar();
                }
            });
        };

        showPdfPreviewAndExecute([detalleSeleccionado], 'prevalidar', confirmPrevalidation);
    };
    // Funciones manejadoras
    const handleImprimirAnalisis = async () => {

        try {
            if (!detalleSeleccionado) {
                Swal.fire({
                    text: 'Por favor selecciona un examen.',
                    icon: 'warning'
                })
                return;
            }
            else {


                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                // Obtener el usuario actual y formatearlo a 20 caracteres
                const usuarioActual = (user ? user.codigoUsuario : "ADMIN").padEnd(20, ' ');
                
                // Obtener el tipo de validación del detalle seleccionado
                // idTipoAprobacion: 1 = Sin Validar, 2 = Pre Valido, 3 = Validado
                const idTipoValidacion = detalleSeleccionado.idTipoAprobacion || 1;
                
                // Construir la URL con los parámetros
                const url = `${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirvariosSeleccionadoExamenFormato?usuario=${encodeURIComponent(usuarioActual)}&idTipoValidacion=${idTipoValidacion}`;
                console.log(url);
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify([detalleSeleccionado.idDetalle])
                });
                console.log(detalleSeleccionado);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    // Deserializar error específico del backend para resultados no válidos
                    let errorMessage = `Error ${response.status}: ${response.statusText}`;
                    
                    try {
                        const errorData = await response.json();
                        
                        if (errorData.detail) {
                            // Error con formato RFC 7231 (como el de resultados no válidos)
                            errorMessage = errorData.detail;
                        } else if (errorData.message) {
                            // Error con formato message estándar
                            errorMessage = errorData.message;
                        } else if (errorData.errors) {
                            // Error con formato de validación
                            errorMessage = Object.values(errorData.errors).flat().join(', ');
                        }
                    } catch (parseError) {
                        // Si no se puede parsear la respuesta JSON, mantener mensaje por defecto
                        console.error('Error parsing response JSON:', parseError);
                    }
                    
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }

            }


        }
        catch (error) {
            console.error('Error al imprimir la orden de trabajo:', error);
            alert('Hubo un error al imprimir Examen.');
        }
    };

    // --- Funciones de validación para el detalle seleccionado ---

    function pickDetailFields(detail, fields) {
        return fields.reduce((acc, field) => {
            if (detail[field] !== undefined) {
                acc[field] = detail[field];
            }
            return acc;
        }, {});
    }

    const ejecutarPrevalidar = async () => {
        if (!detalleSeleccionado) return;

        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];



        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 2, // Cambiar a "Pre Valido"
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        console.log(updateData);
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobado: new Date().toISOString().slice(0, -1),
                    idTipoAprobacion: 2, // "Pre Valido"
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                console.log(histData);
                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Prevalidado", "El detalle ha sido prevalidado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: 1 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al prevalidar.", "error");
        }
    };


    const ejecutarQuitarPrevalidar = async () => {
        if (!detalleSeleccionado) return;

        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];


        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 1, // Cambiar a "Sin Pre Validar"
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobado: new Date().toISOString(),
                    idTipoAprobacion: 1, // "Sin Pre Validar"
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Quitado", "La prevalidación ha sido removida.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, idTipoAprobacion: 1 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al quitar prevalidación.", "error");
        }
    };

    // Funciones manejadoras
    const handleQuitarPrevalidar = () => {

        if (!detalleSeleccionado) {
            Swal.fire({
                text: 'Por favor selecciona un examen.',
                icon: 'warning'
            });
            return;
        }

        // Verificar si el detalle puede quitarse la prevalidación
        if (!puedeQuitarPrevalidacion(detalleSeleccionado)) {
            Swal.fire({
                title: 'No se puede quitar la prevalidación',
                text: 'Solo se puede quitar la prevalidación de exámenes que estén prevalidados.',
                icon: 'warning'
            });
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea anular la pre validacion de este examen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Quitar Prevalidación',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarQuitarPrevalidar();
            }
        });
    };


    const ejecutarValidar = async () => {
        if (!detalleSeleccionado) return;


        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];



        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 3, // Cambiar a "Valido"
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });

            if (response.ok) {

                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobado: new Date().toISOString().slice(0, -1),
                    idTipoAprobacion: 3, // "Valido"
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Validado", "El detalle ha sido validado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: 2 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al validar.", "error");
        }
    }; const handleValidar = () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        // Use selected details if available, otherwise use single selected detail
        const detallesParaValidar = selectedDetalles.length > 0 ? selectedDetalles :
            detalleSeleccionado ? [detalleSeleccionado] : [];

        if (detallesParaValidar.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona al menos un examen.',
                icon: 'warning'
            });
            return;
        }

        // Verificar que todos los detalles puedan ser validados (deben estar prevalidados)
        const detallesNoPrevalidados = detallesParaValidar.filter(detalle => !puedeValidar(detalle));
        if (detallesNoPrevalidados.length > 0) {
            Swal.fire({
                title: 'No se puede validar',
                text: 'Solo se pueden validar exámenes que estén previamente prevalidados. Hay exámenes seleccionados que no están prevalidados.',
                icon: 'warning'
            });
            return;
        }

        // Show PDF preview before confirming validation
        const confirmValidation = () => {
            Swal.fire({
                title: '¿Está seguro?',
                text: `¿Esta seguro de desea validar ${detallesParaValidar.length === 1 ? 'este examen' : 'estos exámenes'}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Validar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    handleValidarMultiple();
                }
            });
        };

        showPdfPreviewAndExecute(detallesParaValidar, 'validar', confirmValidation);
    };

    const ejecutarInvalidar = async () => {
        if (!detalleSeleccionado) return;

        console.log('Ejecutando invalidar para:', detalleSeleccionado);

        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];

        // Volvemos a prevalidado (idTipoAprobacion = 2)
        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 2, // Cambiar a "Pre Valido"
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        console.log('Datos para invalidar:', updateData);

        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });

            console.log('Respuesta de invalidar:', response.status, response.statusText);

            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobado: new Date().toISOString().slice(0, -1),
                    idTipoAprobacion: 2, // "Pre Valido"
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };

                console.log('Datos para histórico:', histData);

                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });

                console.log('Respuesta de histórico:', histResponse.status, histResponse.statusText);

                if (histResponse.ok) {
                    Swal.fire("Invalidado", "El detalle se ha revertido a prevalidado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, idTipoAprobacion: 2 });
                    // Refrescar la lista de detalles
                    if (ordenSeleccionada?.idOrdenMedica) {
                        cargarDetallesOrden(ordenSeleccionada.idOrdenMedica);
                    }
                } else {
                    const histError = await histResponse.text();
                    console.error('Error en histórico:', histError);
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                const detailError = await response.text();
                console.error('Error al actualizar detalle:', detailError);
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error('Error completo en ejecutarInvalidar:', error);
            Swal.fire("Error", "Error al invalidar.", "error");
        }
    };


    const handleInvalidar = () => {
        if (!detalleSeleccionado) {
            Swal.fire({
                text: 'Por favor selecciona un examen.',
                icon: 'warning'
            });
            return;
        }

        // Verificar si el detalle puede ser invalidado
        if (!puedeInvalidar(detalleSeleccionado)) {
            Swal.fire({
                title: 'No se puede invalidar',
                text: 'Solo se pueden invalidar exámenes que estén validados o en estado validado final.',
                icon: 'warning'
            });
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea invalidar este examen? Esto lo regresará al estado prevalidado.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Invalidar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarInvalidar();
            }
        });
    };

    const handleResultados = () => {


        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro que desea llenar los datos de los analisis de esta orden de trabajo?',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarResultados();
            }
        });
    };

    const ejecutarResultados = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Lógica para Prevalidar
            setNumericCodigo(selectedOrdenTrabajo); // Asigna el código de la orden seleccionada
            setOpenResultadosModal(true); // Abre el modal

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al llenar los resultados de los examenes.',
            });
        }
    };


    // --- Funciones para "Atendida" ---
    const handleAtendida = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea marcar esta orden como Atendida?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Atendida',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarAtendida();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarAtendida = async () => {
        try {
            // Crear los datos de actualización sin propagar todo el objeto selectedOrdenTrabajo
            // para evitar conflictos de serialización JSON
            const OrdeData = {
                idOrdenMedica: selectedOrdenTrabajo.idOrdenMedica,
                idOrdenMedicaMes: selectedOrdenTrabajo.idOrdenMedicaMes,
                idCliente: selectedOrdenTrabajo.idCliente,
                correo: selectedOrdenTrabajo.correo,
                idBarrioColonia: selectedOrdenTrabajo.idBarrioColonia,
                fechaOrdenMedica: selectedOrdenTrabajo.fechaOrdenMedica,
                duracion: selectedOrdenTrabajo.duracion,
                idTipoDuracion: selectedOrdenTrabajo.idTipoDuracion,
                idTipoPago: selectedOrdenTrabajo.idTipoPago,
                valorVenta: selectedOrdenTrabajo.valorVenta,
                valorDescuento: selectedOrdenTrabajo.valorDescuento,
                valorRecargo: selectedOrdenTrabajo.valorRecargo,
                telefono: selectedOrdenTrabajo.telefono,
                celular: selectedOrdenTrabajo.celular,
                idSucursal: selectedOrdenTrabajo.idSucursal,
                idMedico: selectedOrdenTrabajo.idMedico,
                idOrigen: selectedOrdenTrabajo.idOrigen,
                idMedioPago: selectedOrdenTrabajo.idMedioPago,
                enviarXWhatsapp: selectedOrdenTrabajo.enviarXWhatsapp,
                enviarXCorreo: selectedOrdenTrabajo.enviarXCorreo,
                enviarXApp: selectedOrdenTrabajo.enviarXApp,
                imprimir: selectedOrdenTrabajo.imprimir,
                porcetajeCopago: selectedOrdenTrabajo.porcetajeCopago,
                idPoliza: selectedOrdenTrabajo.idPoliza,
                polizaValorMinimo: selectedOrdenTrabajo.polizaValorMinimo,
                polizaValorMaximo: selectedOrdenTrabajo.polizaValorMaximo,
                polizaPrevalidado: selectedOrdenTrabajo.polizaPrevalidado,
                idSucursalEntrega: selectedOrdenTrabajo.idSucursalEntrega,
                polizaNumeroTransaccion: selectedOrdenTrabajo.polizaNumeroTransaccion,
                polizaNumeroVericacion: selectedOrdenTrabajo.polizaNumeroVericacion,
                polizaDeduccible: selectedOrdenTrabajo.polizaDeduccible,
                polizaElegible: selectedOrdenTrabajo.polizaElegible,
                idTipo: selectedOrdenTrabajo.idTipo,
                idTipoCliente: selectedOrdenTrabajo.idTipoCliente,
                ingresadoPor: selectedOrdenTrabajo.ingresadoPor,
                fechaRecepcion: selectedOrdenTrabajo.fechaRecepcion,
                fechaEntrega: selectedOrdenTrabajo.fechaEntrega,
                idOrdenParaControl: selectedOrdenTrabajo.idOrdenParaControl,
                observaciones: selectedOrdenTrabajo.observaciones,
                entregado: selectedOrdenTrabajo.entregado,
                modificacion: 4, // Estado "Atendida" - resultados listos, orden no modificable
                fechaModificacion: new Date().toISOString(),
                modificadoPor: user ? user.codigoUsuario : 'ADMIN',
                fechaAtendida: fechaActualLocalISO(),
                // fechaAtendida: new Date().toISOString().slice(0, -1),
                
            }
            console.log('Datos para marcar como Atendida:', OrdeData);
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(OrdeData),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden marcada como Atendida',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al actualizar la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    // --- Funciones para "Reactivar" ---
    const handleReactivar = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea reactivar esta orden de trabajo?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Reactivar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarReactivar();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarReactivar = async () => {
        try {
            const OrdeData = {
                idOrdenMedica: selectedOrdenTrabajo.idOrdenMedica,
                idOrdenMedicaMes: selectedOrdenTrabajo.idOrdenMedicaMes,
                idCliente: selectedOrdenTrabajo.idCliente,
                correo: selectedOrdenTrabajo.correo,
                idBarrioColonia: selectedOrdenTrabajo.idBarrioColonia,
                fechaOrdenMedica: selectedOrdenTrabajo.fechaOrdenMedica,
                duracion: selectedOrdenTrabajo.duracion,
                idTipoDuracion: selectedOrdenTrabajo.idTipoDuracion,
                idTipoPago: selectedOrdenTrabajo.idTipoPago,
                valorVenta: selectedOrdenTrabajo.valorVenta,
                valorDescuento: selectedOrdenTrabajo.valorDescuento,
                valorRecargo: selectedOrdenTrabajo.valorRecargo,
                telefono: selectedOrdenTrabajo.telefono,
                celular: selectedOrdenTrabajo.celular,
                idSucursal: selectedOrdenTrabajo.idSucursal,
                idMedico: selectedOrdenTrabajo.idMedico,
                idOrigen: selectedOrdenTrabajo.idOrigen,
                idMedioPago: selectedOrdenTrabajo.idMedioPago,
                enviarXWhatsapp: selectedOrdenTrabajo.enviarXWhatsapp,
                enviarXCorreo: selectedOrdenTrabajo.enviarXCorreo,
                enviarXApp: selectedOrdenTrabajo.enviarXApp,
                imprimir: selectedOrdenTrabajo.imprimir,
                porcetajeCopago: selectedOrdenTrabajo.porcetajeCopago,
                idPoliza: selectedOrdenTrabajo.idPoliza,
                polizaValorMinimo: selectedOrdenTrabajo.polizaValorMinimo,
                polizaValorMaximo: selectedOrdenTrabajo.polizaValorMaximo,
                polizaPrevalidado: selectedOrdenTrabajo.polizaPrevalidado,
                idSucursalEntrega: selectedOrdenTrabajo.idSucursalEntrega,
                polizaNumeroTransaccion: selectedOrdenTrabajo.polizaNumeroTransaccion,
                polizaNumeroVericacion: selectedOrdenTrabajo.polizaNumeroVericacion,
                polizaDeduccible: selectedOrdenTrabajo.polizaDeduccible,
                polizaElegible: selectedOrdenTrabajo.polizaElegible,
                idTipo: selectedOrdenTrabajo.idTipo,
                idTipoCliente: selectedOrdenTrabajo.idTipoCliente,
                ingresadoPor: selectedOrdenTrabajo.ingresadoPor,
                fechaRecepcion: selectedOrdenTrabajo.fechaRecepcion,
                fechaEntrega: selectedOrdenTrabajo.fechaEntrega,
                idOrdenParaControl: selectedOrdenTrabajo.idOrdenParaControl,
                observaciones: selectedOrdenTrabajo.observaciones,
                entregado: selectedOrdenTrabajo.entregado,
                modificacion: 2, // Estado "Reactivar" - orden vuelve a estar en proceso
                fechaModificacion: new Date().toISOString(),
                modificadoPor: user ? user.codigoUsuario : 'ADMIN',
                fechaAtendida: selectedOrdenTrabajo.fechaAtendida,
            }
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(OrdeData),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden reactivada exitosamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al reactivar la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    // --- Funciones para "Anular" ---
    const handleAnular = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea anular esta orden de trabajo?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Anular',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarAnular();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarAnular = async () => {
        try {
            // Crear los datos de actualización sin propagar todo el objeto selectedOrdenTrabajo
            // para evitar conflictos de serialización JSON
            const OrdeData = {
                idOrdenMedica: selectedOrdenTrabajo.idOrdenMedica,
                idOrdenMedicaMes: selectedOrdenTrabajo.idOrdenMedicaMes,
                idCliente: selectedOrdenTrabajo.idCliente,
                correo: selectedOrdenTrabajo.correo,
                idBarrioColonia: selectedOrdenTrabajo.idBarrioColonia,
                fechaOrdenMedica: selectedOrdenTrabajo.fechaOrdenMedica,
                duracion: selectedOrdenTrabajo.duracion,
                idTipoDuracion: selectedOrdenTrabajo.idTipoDuracion,
                idTipoPago: selectedOrdenTrabajo.idTipoPago,
                valorVenta: selectedOrdenTrabajo.valorVenta,
                valorDescuento: selectedOrdenTrabajo.valorDescuento,
                valorRecargo: selectedOrdenTrabajo.valorRecargo,
                telefono: selectedOrdenTrabajo.telefono,
                celular: selectedOrdenTrabajo.celular,
                idSucursal: selectedOrdenTrabajo.idSucursal,
                idMedico: selectedOrdenTrabajo.idMedico,
                idOrigen: selectedOrdenTrabajo.idOrigen,
                idMedioPago: selectedOrdenTrabajo.idMedioPago,
                enviarXWhatsapp: selectedOrdenTrabajo.enviarXWhatsapp,
                enviarXCorreo: selectedOrdenTrabajo.enviarXCorreo,
                enviarXApp: selectedOrdenTrabajo.enviarXApp,
                imprimir: selectedOrdenTrabajo.imprimir,
                porcetajeCopago: selectedOrdenTrabajo.porcetajeCopago,
                idPoliza: selectedOrdenTrabajo.idPoliza,
                polizaValorMinimo: selectedOrdenTrabajo.polizaValorMinimo,
                polizaValorMaximo: selectedOrdenTrabajo.polizaValorMaximo,
                polizaPrevalidado: selectedOrdenTrabajo.polizaPrevalidado,
                idSucursalEntrega: selectedOrdenTrabajo.idSucursalEntrega,
                polizaNumeroTransaccion: selectedOrdenTrabajo.polizaNumeroTransaccion,
                polizaNumeroVericacion: selectedOrdenTrabajo.polizaNumeroVericacion,
                polizaDeduccible: selectedOrdenTrabajo.polizaDeduccible,
                polizaElegible: selectedOrdenTrabajo.polizaElegible,
                idTipo: selectedOrdenTrabajo.idTipo,
                idTipoCliente: selectedOrdenTrabajo.idTipoCliente,
                ingresadoPor: selectedOrdenTrabajo.ingresadoPor,
                fechaRecepcion: selectedOrdenTrabajo.fechaRecepcion,
                fechaEntrega: selectedOrdenTrabajo.fechaEntrega,
                idOrdenParaControl: selectedOrdenTrabajo.idOrdenParaControl,
                observaciones: selectedOrdenTrabajo.observaciones,
                entregado: selectedOrdenTrabajo.entregado,
                modificacion: 3, // Estado "Anulada"
                fechaModificacion: new Date().toISOString(),
                modificadoPor: user ? user.codigoUsuario : 'ADMIN'
            };
            
            console.log('Datos para anular orden:', OrdeData);
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(OrdeData),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden anulada exitosamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al anular la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    // --- Funciones para "Entregada" ---
    // const handleEntregada = () => {
    //     if (selectedOrdenTrabajo) {
    //         Swal.fire({
    //             title: '¿Está seguro?',
    //             text: '¿Desea marcar esta orden como Entregada?',
    //             icon: 'warning',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sí, Entregada',
    //             cancelButtonText: 'Cancelar',
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 ejecutarEntregada();
    //             }
    //         });
    //     } else {
    //         Swal.fire({
    //             text: 'Por favor selecciona una orden de trabajo.',
    //             icon: 'warning'
    //         })
    //         return;
    //     }
    // };

    const handleEntregada = async () => {
        if (selectedOrdenTrabajo) {
            // ✅ Cargar comentarios existentes desde la API
            try {
                const response = await fetch(
                    `${server}/MgOrdenesMedicasComentariosEntregas/porOrden/${selectedOrdenTrabajo.idOrdenMedica}`
                );

                if (response.ok) {
                    const data = await response.json();
                    const comentariosExistentes = (data.$values || data || []).map(c => ({
                        id: c.idComentarioEntrega || c.id, // ✅ Manejar ambos nombres de campo
                        comentarios: c.comentarios,
                        fechaIngreso: c.fechaIngreso,
                        ingresadoPor: c.ingresadoPor,
                        isNew: false
                    }));
                    console.log('📋 Comentarios cargados:', comentariosExistentes);
                    setComentariosEntrega(comentariosExistentes);
                } else {
                    setComentariosEntrega([]);
                }
            } catch (error) {
                console.error('Error al cargar comentarios:', error);
                setComentariosEntrega([]);
            }

            setOpenComentarioEntrega(true);
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
        }
    };





    const guardarComentarioEntrega = async (comentarios, comentariosEliminados = []) => {
        try {
            console.log('💾 Guardando comentarios:', comentarios);
            console.log('🗑️ Comentarios a eliminar:', comentariosEliminados);
            
            // 1. Marcar la orden como entregada
            const {
                idOrdenMedica,
                idOrdenMedicaMes,
                idCliente,
                correo,
                idBarrioColonia,
                fechaOrdenMedica,
                duracion,
                idTipoDuracion,
                idTipoPago,
                valorVenta,
                valorDescuento,
                valorRecargo,
                telefono,
                celular,
                idSucursal,
                idMedico,
                idOrigen,
                idMedioPago,
                enviarXWhatsapp,
                enviarXCorreo,
                enviarXApp,
                imprimir,
                porcetajeCopago,
                idPoliza,
                polizaValorMinimo,
                polizaValorMaximo,
                polizaPrevalidado,
                idSucursalEntrega,
                polizaNumeroTransaccion,
                polizaNumeroVericacion,
                polizaDeduccible,
                polizaElegible,
                idTipo,
                idTipoCliente,
                ingresadoPor,
                modificadoPor,
                fechaRecepcion,
                fechaEntrega,
                idOrdenParaControl,
                observaciones
            } = selectedOrdenTrabajo;

            const OrdenTrabajoData = {
                idOrdenMedica,
                idOrdenMedicaMes,
                idCliente,
                correo,
                idBarrioColonia,
                fechaOrdenMedica,
                duracion,
                idTipoDuracion,
                idTipoPago,
                valorVenta,
                valorDescuento,
                valorRecargo,
                telefono,
                celular,
                idSucursal,
                idMedico,
                idOrigen,
                idMedioPago,
                enviarXWhatsapp,
                enviarXCorreo,
                enviarXApp,
                imprimir,
                porcetajeCopago,
                idPoliza,
                polizaValorMinimo,
                polizaValorMaximo,
                polizaPrevalidado,
                idSucursalEntrega,
                polizaNumeroTransaccion,
                polizaNumeroVericacion,
                polizaDeduccible,
                polizaElegible,
                idTipo,
                idTipoCliente,
                ingresadoPor,
                fechaRecepcion,
                fechaEntrega,
                idOrdenParaControl,
                observaciones,
                entregado: true,
                fechaModificacion: new Date().toISOString(),
                modificadoPor: user ? user.codigoUsuario : 'ADMIN'
            };

            const response = await fetch(`${server}/MgOrdenesMedicas/${idOrdenMedica}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(OrdenTrabajoData),
            });

            console.log(response);
            if (!response.ok) {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Error inesperado');
                return Swal.fire({ icon: 'error', title: `Error ${response.status}`, text: errorMessage });
            }

            // 2. ✅ Eliminar comentarios marcados para eliminación
            const username = user ? `${user.codigoUsuario}/` : 'ADMIN/';
            for (const idComentario of comentariosEliminados) {
                try {
                    const deleteResponse = await fetch(
                        `${server}/MgOrdenesMedicasComentariosEntregas/${idComentario}/${username}`,
                        { method: 'DELETE' }
                    );
                    if (!deleteResponse.ok) {
                        console.error('Error al eliminar comentario:', idComentario, deleteResponse.status);
                    } else {
                        console.log('✅ Comentario eliminado exitosamente:', idComentario);
                    }
                } catch (error) {
                    console.error('Error al eliminar comentario:', error);
                }
            }

            // 3. ✅ Solo guardar comentarios NUEVOS (isNew === true)
            const comentariosNuevos = comentarios.filter(c => c.isNew);
            console.log('📝 Comentarios nuevos a guardar:', comentariosNuevos);
            
            for (const comentario of comentariosNuevos) {
                const payloadComentario = {
                    idOrdenMedica: selectedOrdenTrabajo.idOrdenMedica,
                    comentarios: comentario.comentarios,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                };

                const responseComentario = await fetch(`${server}/MgOrdenesMedicasComentariosEntregas`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payloadComentario)
                });

                if (!responseComentario.ok) {
                    console.error('Error al guardar el comentario de entrega:', responseComentario.statusText);
                }
            }

            // 4. ✅ Recargar comentarios de esta orden para actualizar la vista
            await fetchComentariosEntrega(selectedOrdenTrabajo.idOrdenMedica);

            Swal.fire({
                icon: 'success',
                title: 'Orden marcada como Entregada',
                text: `Se guardaron ${comentariosNuevos.length} comentario(s) nuevo(s)`,
                showConfirmButton: false,
                timer: 1500,
            });

            setOpenComentarioEntrega(false);
            fetchOrdenesTrabajos(searchQuery);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al actualizar',
                text: error.message
            });
        }
    };




    const ejecutarEntregada = async () => {
        try {
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...selectedOrdenTrabajo,
                    entregado: true,
                }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden marcada como Entregada',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al actualizar la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };



    // --- PDF Preview Helper Functions ---
    const showPdfPreviewAndExecute = (detalles, actionType, actionFunction) => {
        if (!detalles || detalles.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona al menos un examen.',
                icon: 'warning'
            });
            return;
        }

        // Set the pending action and open PDF preview
        setPendingValidationAction({ type: actionType, function: actionFunction, detalles: detalles });
        setOpenPdfPreview(true);
    };

    const handlePdfPreviewConfirm = () => {
        if (pendingValidationAction && pendingValidationAction.function) {
            pendingValidationAction.function();
        }
        setPendingValidationAction(null);
    };

    const handlePdfPreviewCancel = () => {
        setPendingValidationAction(null);
        setOpenPdfPreview(false);
    };

    // 2. Función para alternar la selección de un detalle
    const toggleDetalleSelection = (detalle) => {
        console.log(detalle);
        setDetalleSeleccionado(detalle);
        setSelectedDetalles((prevSelected) => {
            // Si ya está seleccionado, lo quitamos; si no, lo agregamos
            const isSelected = prevSelected.some(d => d.idDetalle === detalle.idDetalle);
            if (isSelected) {
                return prevSelected.filter(d => d.idDetalle !== detalle.idDetalle);
            } else {
                return [...prevSelected, detalle];
            }
        });
    };

    // Función refactorizada para prevalidar un detalle individual
    const ejecutarPrevalidarDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 2,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };
        console.log(updateData);
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            // Deserializar error específico para validación de detalles
            let errorMessage = `Error al prevalidar el detalle ${detalle.idDetalle}`;
            
            try {
                const errorData = await response.json();
                
                if (errorData.detail) {
                    // Error con formato RFC 7231
                    errorMessage = `${errorData.detail} (Detalle: ${detalle.idDetalle})`;
                } else if (errorData.message) {
                    // Error con formato message estándar
                    errorMessage = `${errorData.message} (Detalle: ${detalle.idDetalle})`;
                } else if (errorData.errors) {
                    // Error con formato de validación
                    errorMessage = `${Object.values(errorData.errors).flat().join(', ')} (Detalle: ${detalle.idDetalle})`;
                }
            } catch (parseError) {
                // Si no se puede parsear, mantener mensaje genérico
                console.error('Error parsing response JSON:', parseError);
            }
            
            throw new Error(errorMessage);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2, // "Pre Valido"
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };    // Función para prevalidar múltiples detalles
    const handlePrevalidarMultiple = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        if (selectedDetalles.length === 0) {
            Swal.fire({ text: 'Por favor, selecciona al menos un examen.', icon: 'warning' });
            return;
        }

        // Verificamos si alguno está validado (3).
        const algunoValidado = selectedDetalles.some(d => d.idTipoAprobacion === 3);
        if (algunoValidado) {
            Swal.fire(
                "Error",
                "No se puede prevalidar: hay al menos un examen que ya está validado.",
                "error"
            );
            return;
        }

        // Show PDF preview before confirming prevalidation
        const confirmPrevalidation = () => {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea prevalidar los exámenes seleccionados?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Prevalidar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        // Guardar los IDs de los detalles seleccionados antes de la operación
                        const idsSeleccionados = selectedDetalles.map(d => d.idDetalle);
                        
                        await Promise.all(selectedDetalles.map(detalle => ejecutarPrevalidarDetalle(detalle)));
                        Swal.fire("Prevalidados", "Los detalles han sido prevalidados.", "success");
                        
                        // Recargar detalles
                        await refreshDetalles();
                        
                        // Restaurar la selección con los detalles actualizados
                        const detallesActualizados = detallesOrdenTrabajo.filter(d => 
                            idsSeleccionados.includes(d.idDetalle)
                        );
                        setSelectedDetalles(detallesActualizados);
                    } catch (error) {
                        console.error(error);
                        Swal.fire("Error", error.message, "error");
                    }
                }
            });
        };

        showPdfPreviewAndExecute(selectedDetalles, 'prevalidar', confirmPrevalidation);
    }; 
    // const handleImprimirDetalles = async () => {
    //     if (selectedDetalles.length === 0) {
    //         Swal.fire({
    //             text: 'Por favor, selecciona al menos un detalle para imprimir.',
    //             icon: 'warning'
    //         });
    //         return;
    //     }

    //     const confirmPrint = async () => {
    //         try {
    //             // Agrupar los detalles por tipo de aprobación
    //             const detallesPorTipoAprobacion = {};

    //             // Recorrer todos los detalles seleccionados y agruparlos
    //             selectedDetalles.forEach(detalle => {
    //                 // Usar "null" como clave si el tipo de aprobación es nulo
    //                 const tipoAprobacion = detalle.idTipoAprobacion !== null
    //                     ? detalle.idTipoAprobacion.toString()
    //                     : "null";

    //                 // Inicializar el array si no existe
    //                 if (!detallesPorTipoAprobacion[tipoAprobacion]) {
    //                     detallesPorTipoAprobacion[tipoAprobacion] = [];
    //                 }

    //                 // Agregar el idDetalle al grupo correspondiente
    //                 detallesPorTipoAprobacion[tipoAprobacion].push(detalle.idDetalle);
    //             });

    //             // Hacer una solicitud por cada grupo de tipo de aprobación
    //             for (const tipoAprobacion in detallesPorTipoAprobacion) {
    //                 const idsDetalles = detallesPorTipoAprobacion[tipoAprobacion];

    //                 // Obtener el usuario actual y formatearlo a 20 caracteres
    //                 const usuarioActual = (user ? user.codigoUsuario : "ADMIN").padEnd(20, ' ');
                    
    //                 // Construir la URL con los parámetros
    //                 const apiUrl = `${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirvariosSeleccionadoExamenFormato?usuario=${encodeURIComponent(usuarioActual)}&idTipoValidacion=${tipoAprobacion}`;

    //                 const response = await fetch(apiUrl, {
    //                     method: 'POST',
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                     },
    //                     body: JSON.stringify(idsDetalles)
    //                 });

    //                 if (!response.ok) {
    //                     // Deserializar error específico para análisis con resultados no válidos
    //                     let errorMessage = `Error al imprimir los detalles con tipo de aprobación ${tipoAprobacion}`;
                        
    //                     try {
    //                         const errorData = await response.json();
                            
    //                         if (errorData.detail) {
    //                             // Error con formato RFC 7231 (como el de resultados no válidos)
    //                             errorMessage = errorData.detail;
    //                         } else if (errorData.message) {
    //                             // Error con formato message estándar
    //                             errorMessage = errorData.message;
    //                         }
    //                     } catch (parseError) {
    //                         // Si no se puede parsear, mantener mensaje genérico
    //                         console.error('Error parsing response JSON:', parseError);
    //                     }
                        
    //                     throw new Error(errorMessage);
    //                 }

    //                 // Obtener el blob de la respuesta y abrirlo en una nueva ventana
    //                 // const blob = await response.blob();
    //                 // const pdfUrl = window.URL.createObjectURL(blob);
    //                 // const newWindow = window.open(pdfUrl, '_blank');

    //                 // if (!newWindow) {
    //                 //     Swal.fire({
    //                 //         icon: 'warning',
    //                 //         title: 'Ventana Bloqueada',
    //                 //         text: 'Por favor, permite las ventanas emergentes para visualizar los documentos.'
    //                 //     });
    //                 //     // Salir del bucle si las ventanas están bloqueadas
    //                 //     break;
    //                 // }

    //                 await response.blob();
    //             }

    //             // Swal.fire({
    //             //     icon: 'success',
    //             //     title: `Detalles enviados a impresión (${Object.keys(detallesPorTipoAprobacion).length} grupo(s)).`,
    //             //     showConfirmButton: false,
    //             //     timer: 1500
    //             // });
    //         } catch (error) {
    //             console.error('Error al imprimir los detalles:', error);
    //             Swal.fire({
    //                 icon: 'error',
    //                 title: 'Error',
    //                 text: error.message || 'Ocurrió un error al imprimir los detalles.'
    //             });
    //         }

    //     };
    //     showPdfPreviewAndExecute(selectedDetalles, 'imprimir', confirmPrint);
    // };

    
const handleImprimirDetalles = async () => {
    if (selectedDetalles.length === 0) {
        Swal.fire({
            text: 'Por favor, selecciona al menos un detalle para imprimir.',
            icon: 'warning'
        });
        return;
    }

    // 🔹 1. Validar que ninguno tenga estado null
    const hayNull = selectedDetalles.some(d => d.idTipoAprobacion === null);

    if (hayNull) {
        Swal.fire({
            icon: 'warning',
            title: 'Selección inválida',
            text: 'No puedes imprimir detalles sin estado de aprobación.'
        });
        return;
    }

    // 🔹 2. Si hay algún "Valido" (3), todos deben ser 3
    const hayValidos = selectedDetalles.some(d => d.idTipoAprobacion === 3);

    if (hayValidos) {
        const todosSonValidos = selectedDetalles.every(d => d.idTipoAprobacion === 3);

        if (!todosSonValidos) {
            Swal.fire({
                icon: 'warning',
                title: 'Selección inválida',
                text: 'No puedes mezclar resultados Validados con Sin Pre Validar o Pre Validados.'
            });
            return;
        }
    }

    const confirmPrint = async () => {
        try {
            const detallesPorTipoAprobacion = {};

            selectedDetalles.forEach(detalle => {
                const tipoAprobacion = detalle.idTipoAprobacion.toString();

                if (!detallesPorTipoAprobacion[tipoAprobacion]) {
                    detallesPorTipoAprobacion[tipoAprobacion] = [];
                }

                detallesPorTipoAprobacion[tipoAprobacion].push(detalle.idDetalle);
            });

            for (const tipoAprobacion in detallesPorTipoAprobacion) {
                const idsDetalles = detallesPorTipoAprobacion[tipoAprobacion];

                const usuarioActual = (user ? user.codigoUsuario : "ADMIN").padEnd(20, ' ');

                const apiUrl = `${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirvariosSeleccionadoExamenFormato?usuario=${encodeURIComponent(usuarioActual)}&idTipoValidacion=${tipoAprobacion}`;

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(idsDetalles)
                });

                if (!response.ok) {
                    let errorMessage = `Error al imprimir los detalles con tipo de aprobación ${tipoAprobacion}`;
                    
                    try {
                        const errorData = await response.json();
                        errorMessage = errorData.detail || errorData.message || errorMessage;
                    } catch (parseError) {
                        console.error('Error parsing response JSON:', parseError);
                    }

                    throw new Error(errorMessage);
                }

                await response.blob();
            }

        } catch (error) {
            console.error('Error al imprimir los detalles:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al imprimir los detalles.'
            });
        }
    };

    showPdfPreviewAndExecute(selectedDetalles, 'imprimir', confirmPrint);
};



    const handleImprimirTodosDetalles = async () => {
        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Por favor, selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Si no hay detalles seleccionados, tomamos todos los de la orden
            const detallesAImprimir = selectedDetalles.length > 0
                ? selectedDetalles
                : detallesOrdenTrabajo;

            if (detallesAImprimir.length === 0) {
                Swal.fire({
                    text: 'No hay detalles disponibles para imprimir.',
                    icon: 'warning'
                });
                return;
            }

            // Agrupar detalles por idTipoAprobacion
            const detallesPorTipoAprobacion = {};

            // Recorrer los detalles y agruparlos por tipo de aprobación
            detallesAImprimir.forEach(detalle => {
                // Usar "null" como clave si el tipo de aprobación es nulo
                const tipoAprobacion = detalle.idTipoAprobacion !== null
                    ? detalle.idTipoAprobacion.toString()
                    : "null";

                // Inicializar el array si no existe
                if (!detallesPorTipoAprobacion[tipoAprobacion]) {
                    detallesPorTipoAprobacion[tipoAprobacion] = [];
                }

                // Agregar el idDetalle al grupo correspondiente
                detallesPorTipoAprobacion[tipoAprobacion].push(detalle.idDetalle);
            });

            // Verificar que todos pertenezcan a la misma orden de trabajo
            const idOrdenSeleccionada = selectedOrdenTrabajo.idOrdenMedica;
            const todosDetallesMismaOrden = detallesAImprimir.every(
                detalle => detalle.idOrdenMedica === idOrdenSeleccionada
            );

            if (!todosDetallesMismaOrden) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Algunos detalles no pertenecen a la orden de trabajo seleccionada.'
                });
                return;
            }

            // Procesar cada grupo de detalles por tipo de aprobación
            for (const tipoAprobacion in detallesPorTipoAprobacion) {
                const idsDetalles = detallesPorTipoAprobacion[tipoAprobacion];

                // Obtener el usuario actual y formatearlo a 20 caracteres
                const usuarioActual = (user ? user.codigoUsuario : "ADMIN").padEnd(20, ' ');
                
                // Construir la URL con los parámetros
                const apiUrl = `${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirvariosSeleccionadoExamenFormato?usuario=${encodeURIComponent(usuarioActual)}&idTipoValidacion=${tipoAprobacion}`;

                // Llamar a la API con el grupo de IDs del mismo tipo de aprobación
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(idsDetalles)
                });

                if (!response.ok) {
                    // Deserializar error específico para análisis con resultados no válidos
                    let errorMessage = `Error al imprimir detalles con tipo de aprobación ${tipoAprobacion}`;
                    
                    try {
                        const errorData = await response.json();
                        
                        if (errorData.detail) {
                            // Error con formato RFC 7231 (como el de resultados no válidos)
                            errorMessage = errorData.detail;
                        } else if (errorData.message) {
                            // Error con formato message estándar
                            errorMessage = errorData.message;
                        }
                    } catch (parseError) {
                        // Si no se puede parsear, mantener mensaje genérico
                        console.error('Error parsing response JSON:', parseError);
                    }
                    
                    throw new Error(errorMessage);
                }

                // Abrir el resultado en una nueva ventana
                const blob = await response.blob();
                const pdfUrl = window.URL.createObjectURL(blob);
                const newWindow = window.open(pdfUrl, '_blank');
                if (!newWindow) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Ventana bloqueada',
                        text: 'Por favor, permite las ventanas emergentes para visualizar los documentos.'
                    });
                }
            }

            Swal.fire({
                icon: 'success',
                title: 'Impresión completada',
                text: `Se imprimieron ${Object.keys(detallesPorTipoAprobacion).length} grupo(s) de detalles.`,
                showConfirmButton: false,
                timer: 1500
            });

        } catch (error) {
            console.error('Error al imprimir los detalles:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al imprimir los detalles.'
            });
        }
    };    // Función para validar múltiples detalles seleccionados
    const handleValidarMultiple = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un detalle.",
                icon: "warning",
            });
            return;
        }

        // Ejemplo: exigir que todos estén en 1 (prevalidado) antes de validarlos
        console.log(selectedDetalles);
        const algunoNoPrevalidado = selectedDetalles.some(d => d.idTipoAprobacion !== 2);
        if (algunoNoPrevalidado) {
            Swal.fire(
                "Error",
                "Todos los exámenes a validar deben estar en prevalidado.",
                "error"
            );
            return;
        }

        // Show PDF preview before confirming validation
        const confirmValidation = () => {
            Swal.fire({
                title: "¿Está seguro?",
                text: "¿Desea validar los detalles seleccionados?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, Validar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        // Guardar los IDs de los detalles seleccionados antes de la operación
                        const idsSeleccionados = selectedDetalles.map(d => d.idDetalle);
                        
                        // Ejecutar la validación de cada detalle seleccionado en paralelo
                        await Promise.all(selectedDetalles.map(detalle => ejecutarValidarDetalle(detalle)));
                        Swal.fire("Validados", "Los detalles han sido validados.", "success");
                        
                        // Recargar detalles
                        await refreshDetalles();
                        
                        // Restaurar la selección con los detalles actualizados
                        const detallesActualizados = detallesOrdenTrabajo.filter(d => 
                            idsSeleccionados.includes(d.idDetalle)
                        );
                        setSelectedDetalles(detallesActualizados);
                    } catch (error) {
                        console.error(error);
                        Swal.fire("Error", error.message, "error");
                    }
                }
            });
        };

        showPdfPreviewAndExecute(selectedDetalles, 'validar', confirmValidation);
    };

    // Función auxiliar que valida un detalle individual y retorna una promesa
    const ejecutarValidarDetalle = async (detalle) => {
        const camposDeseados = [
            "idDetalle",
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "ingresadoPor",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idTipoAnalisis",
            "idTipoPrecio",
            "valorDescuento",
            "evaluada"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 3,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizar el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
        });
        if (!response.ok) {
            throw new Error(`Error al validar el detalle ${detalle.idDetalle}`);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2,
            idOrdenMedicaDetalle: detalle.idDetalle,
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData),
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };

    // Función auxiliar para invalidar un detalle individual
    const ejecutarInvalidarDetalle = async (detalle) => {
        const camposDeseados = [
            "idDetalle",
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "ingresadoPor",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idTipoAnalisis",
            "idTipoPrecio",
            "idTipoAnalisis",
            "valorDescuento",
            "valorVenta",
            "evaluada",
            "comentarios"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 2, // Cambiar de "Valido" a "Pre Valido"
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizar el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
        });
        if (!response.ok) {
            throw new Error(`No se pudo actualizar el detalle ${detalle.idDetalle}`);
        }

        // Insertar el registro en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2, // "Pre Valido"
            idOrdenMedicaDetalle: detalle.idDetalle,
        };

        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData),
        });
        if (!histResponse.ok) {
            throw new Error(`No se pudo insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };

    // Función para invalidar múltiples detalles seleccionados
    const handleInvalidarMultiple = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un examen.",
                icon: "warning",
            });
            return;
        }

        // Ejemplo: exigir que todos estén validados (2) antes de invalidar
        const algunoNoValidado = selectedDetalles.some(d => d.idTipoAprobacion !== 3);
        if (algunoNoValidado) {
            Swal.fire(
                "Error",
                "Todos los exámenes a invalidar deben estar en validado",
                "error"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro?",
            text: "¿Desea invalidar los detalles seleccionados? Esto los revertirá a prevalidado.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Invalidar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Guardar los IDs de los detalles seleccionados antes de la operación
                    const idsSeleccionados = selectedDetalles.map(d => d.idDetalle);
                    
                    await Promise.all(selectedDetalles.map(detalle => ejecutarInvalidarDetalle(detalle)));
                    Swal.fire("Invalidados", "Los detalles han sido invalidados.", "success");
                    
                    // Recargar detalles
                    await refreshDetalles();
                    
                    // Restaurar la selección con los detalles actualizados
                    const detallesActualizados = detallesOrdenTrabajo.filter(d => 
                        idsSeleccionados.includes(d.idDetalle)
                    );
                    setSelectedDetalles(detallesActualizados);
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };

    // Función para recargar los detalles de la orden seleccionada
    const refreshDetalles = async () => {
        if (selectedOrdenTrabajo) {
            try {
                const response = await fetch(
                    `${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${selectedOrdenTrabajo.idOrdenMedica}`
                );
                if (response.ok) {
                    const data = await response.json();
                    // IMPORTANTE: Mantenemos el orden exacto de la API - NO aplicar ordenamiento
                    const detallesFromAPI = data.$values || [];
                    console.log('Orden de detalles refresh desde API:', detallesFromAPI.map(d => ({ 
                        id: d.idDetalle, 
                        descripcion: d.descripcionTipoAnalisis, 
                        estado: d.tipoValidacion,
                        idTipoAprobacion: d.idTipoAprobacion 
                    })));
                    setDetallesOrdenTrabajo(detallesFromAPI);
                } else {
                    console.error('Error al recargar los detalles de la orden de trabajo');
                }
            } catch (error) {
                console.error('Error al recargar los detalles:', error);
            }
        }
    };

    // Función auxiliar para quitar la prevalidación de un detalle individual
    const ejecutarQuitarPrevalidarDetalle = async (detalle) => {
        const camposDeseados = [
            "idDetalle",
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "ingresadoPor",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idTipoAnalisis",
            "idTipoPrecio",
            "idTipoAnalisis",
            "valorDescuento",
            "valorVenta",
            "evaluada",
            "comentarios"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 1,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizamos el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            throw new Error(`No se pudo actualizar el detalle ${detalle.idDetalle}`);
        }

        // Insertamos en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString(),
            idTipoAprobacion: null,
            idOrdenMedicaDetalle: detalle.idDetalle



        };

        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });

        if (!histResponse.ok) {
            throw new Error(`No se pudo insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }

        return updateData;
    };

    // Función para quitar la prevalidación de múltiples detalles seleccionados
    const handleQuitarPrevalidarMultiple = async () => {
        // Verificar si la orden está en estado "Atendida" 
        if (selectedOrdenTrabajo && selectedOrdenTrabajo.modificacion === 4) {
            Swal.fire({
                title: 'Orden Atendida',
                text: 'No se puede modificar una orden que ya está en estado "Atendida". Los resultados están completos.',
                icon: 'warning'
            });
            return;
        }

        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un examen.",
                icon: "warning"
            });
            return;
        }

        // Verificar si todos son prevalidados (1), 
        // pues si alguno está en 2, no se puede quitar la prevalidación.
        const algunoValidado = selectedDetalles.some(d => d.idTipoAprobacion === 3);
        if (algunoValidado) {
            Swal.fire(
                "Error",
                "No se puede quitar la prevalidación de un examen que ya está validado.",
                "error"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro?",
            text: "¿Desea quitar la prevalidación de los exámenes seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, quitar prevalidación",
            cancelButtonText: "Cancelar"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Guardar los IDs de los detalles seleccionados antes de la operación
                    const idsSeleccionados = selectedDetalles.map(d => d.idDetalle);
                    
                    // Ejecuta la operación en paralelo para todos los detalles seleccionados
                    await Promise.all(selectedDetalles.map(detalle => ejecutarQuitarPrevalidarDetalle(detalle)));
                    Swal.fire("Quitado", "La prevalidación ha sido removida de los detalles seleccionados.", "success");
                    
                    // Recargar detalles
                    await refreshDetalles();
                    
                    // Restaurar la selección con los detalles actualizados
                    const detallesActualizados = detallesOrdenTrabajo.filter(d => 
                        idsSeleccionados.includes(d.idDetalle)
                    );
                    setSelectedDetalles(detallesActualizados);
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };    // Función para verificar el estado de facturación de una orden
    const checkFacturacionStatus = async (idOrdenMedica, valorTotalOrden, valorDescuentoOrden = 0) => {
        try {
            const response = await fetch(`${server}/FtFacturas/facturasbyorden/${idOrdenMedica}`);
            
            // Calcular valor NETO de la orden
            const valorOrdenBruto = parseFloat(valorTotalOrden) || 0;
            const descuentoOrden = parseFloat(valorDescuentoOrden) || 0;
            const valorOrdenNeto = valorOrdenBruto - descuentoOrden;
            
            if (!response.ok) {
                return { status: 'sin-facturar', totalFacturado: 0, pendiente: valorOrdenNeto };
            }

            const data = await response.json();
            const facturas = data.$values || data || [];

            if (facturas.length === 0) {
                return { status: 'sin-facturar', totalFacturado: 0, pendiente: valorOrdenNeto };
            }

            // Sumar el total NETO de todas las facturas (valor - descuento)
            const totalFacturadoNeto = facturas.reduce((sum, factura) => {
                const valorBruto = parseFloat(factura.valorVenta) || 0;
                const descuentoFactura = parseFloat(factura.valorDescuento) || 0;
                return sum + (valorBruto - descuentoFactura);
            }, 0);

            // Calcular el monto pendiente usando valores NETOS
            const montoPendiente = valorOrdenNeto - totalFacturadoNeto;

            // Si la facturación cubre la orden o la excede, se considera completa
            if (montoPendiente <= 0.01)
                return { status: 'facturado-completo', totalFacturado: totalFacturadoNeto, pendiente: 0 };
            else if (totalFacturadoNeto > 0)
                return { status: 'facturado-parcial', totalFacturado: totalFacturadoNeto, pendiente: montoPendiente };
            else
                return { status: 'sin-facturar', totalFacturado: 0, pendiente: valorOrdenNeto };
        } catch (error) {
            console.error('Error al verificar facturación:', error);
            const valorOrdenBruto = parseFloat(valorTotalOrden) || 0;
            const descuentoOrden = parseFloat(valorDescuentoOrden) || 0;
            const valorOrdenNeto = valorOrdenBruto - descuentoOrden;
            return { status: 'sin-facturar', totalFacturado: 0, pendiente: valorOrdenNeto };
        }
    };    // Función para cargar el estado de facturación de todas las órdenes visibles
    const loadFacturacionStatus = async (ordenes) => {
        console.log('Cargando estado de facturación para', ordenes.length, 'órdenes');

        const statusPromises = ordenes.map(async (orden) => {
            const status = await checkFacturacionStatus(orden.idOrdenMedica, orden.valorVenta, orden.valorDescuento || 0);
            const valorNeto = (parseFloat(orden.valorVenta) || 0) - (parseFloat(orden.valorDescuento) || 0);
            console.log(`Orden ${orden.idOrdenMedica}: status = ${status.status}, valor neto = ${valorNeto.toFixed(2)}`);
            return { idOrdenMedica: orden.idOrdenMedica, status };
        });

        const results = await Promise.all(statusPromises);
        const statusMap = {};
        results.forEach(result => {
            statusMap[result.idOrdenMedica] = result.status;
        });

        console.log('Estado de facturación cargado:', statusMap);
        setFacturacionStatus(statusMap);
    };
    const handleCloseReimprimirPreview = () => {
        if (reimprimirPdfUrl) {
            window.URL.revokeObjectURL(reimprimirPdfUrl);
            setReimprimirPdfUrl(null);
        }
        setOpenReimprimirPreview(false);
        setReimprimirError(null);
    };

    const handleReimprimirPreview = async () => {
        if (!selectedOrdenTrabajo) {
            Swal.fire({ text: 'Por favor selecciona una orden de trabajo.', icon: 'warning' });
            return;
        }
        setReimprimirLoading(true);
        setReimprimirError(null);
        setOpenReimprimirPreview(true);
        try {
            const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}?esReimpresion=true`, {
                method: 'POST',
            });
            if (!response.ok) {
                throw new Error(`Error al generar el PDF: ${response.status} ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setReimprimirPdfUrl(url);
        } catch (err) {
            setReimprimirError(err.message || 'Error al generar la vista previa del PDF');
        } finally {
            setReimprimirLoading(false);
        }
    };

    // Sobre Preview Modal handlers
    const handleCloseSobrePreview = () => {
        setOpenSobrePreview(false);
    };

    const handleSobrePreviewConfirm = () => {
        // After confirming the preview, print the envelope
        handleCloseSobrePreview();

        // Here we could add additional logic if needed after printing
        Swal.fire({
            icon: 'success',
            title: 'Sobre enviado a impresión',
            showConfirmButton: false,
            timer: 1500
        });
    };      // Componente para mostrar el estado de facturación
    const FacturacionStatusIcon = ({ idOrdenMedica }) => {
        const status = facturacionStatus[idOrdenMedica];

        if (!status) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '100%',
                        height: '32px'
                    }}
                >
                    <CircularProgress size={16} />
                </Box>
            );
        }

        switch (status.status) {
            case 'facturado-completo':
                return (
                    <Box
                        sx={{
                            backgroundColor: '#4caf50',
                            color: 'white',
                            padding: '4px 2px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '32px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                        title="Completamente facturado"
                    >
                        ✓
                    </Box>
                );
            case 'facturado-parcial':
                return (
                    <Box
                        sx={{
                            backgroundColor: '#f44336',
                            color: 'white',
                            padding: '4px 2px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // minWidth: '28px',
                            width: '100%',
                            height: '32px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                        title={`Parcialmente facturado - Monto pendiente: L. ${parseFloat(status.pendiente).toFixed(2)}`}
                    >
                        ⚠
                    </Box>
                );
            case 'sin-facturar':
            default:
                return (
                    <Box
                        sx={{
                            backgroundColor: '#9e9e9e',
                            color: 'white',
                            padding: '4px 2px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '32px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                        title="Sin facturar"
                    >
                        ✗
                    </Box>
                );
        }
    };

    // const handleCloseFacturaModal = async () => {
    //     setOpenFacturaModal(false);
    //     // vuelve a pedir los datos (asegúrate de pasar los filtros actuales)
    //     fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin);

    //      // 🔥 Volver a ejecutar exactamente la lógica de selección
    //     if (selectedOrdenTrabajo) {
    //         await handleSelectOrdenTrabajo(selectedOrdenTrabajo);
    //     }
    // };
 const handleCloseFacturaModal = async () => {
    setOpenFacturaModal(false);

    if (!selectedOrdenTrabajo) return;

    const ordenTemp = selectedOrdenTrabajo;

    // 🔹 1. Actualizar la lista de órdenes (mantener filtros actuales)
    await fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin);

    // 🔹 2. Deseleccionar para disparar useEffect de facturaPagada
    setSelectedOrdenTrabajo(null);

    // 🔹 3. Pequeño delay para volver a seleccionar la orden y recargar todos los datos
    setTimeout(() => {
        handleSelectOrdenTrabajo(ordenTemp);
    }, 0);
};



    // Helper function para deserializar errores del backend
    const parseBackendError = async (response, defaultMessage = 'Ocurrió un error inesperado') => {
        try {
            const errorData = await response.json();
            
            if (errorData.detail) {
                // Error con formato RFC 7231 (como el de resultados no válidos)
                return errorData.detail;
            } else if (errorData.message) {
                // Error con formato message estándar
                return errorData.message;
            } else if (errorData.errors) {
                // Error con formato de validación
                return Object.values(errorData.errors).flat().join(', ');
            }
            
            return defaultMessage;
        } catch (parseError) {
            // Si no se puede parsear la respuesta JSON, retornar mensaje por defecto
            return defaultMessage;
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    <h2>Listado de Ordenes de Trabajo</h2>
                    <br />
                    <Grid container spacing={1} alignItems="center" style={{ marginBottom: '20px' }}>
                        {/* Autocomplete sucursal - Filtro local de pantalla */}
                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                size="small"
                                options={sucursales}
                                getOptionLabel={(option) => option.nombreSucursal || ''}
                                value={typeof sucursalFiltro === 'object' ? sucursalFiltro : null}
                                onChange={handleSucursalSeleccionada}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sucursal" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                size="small"
                                options={modulos}
                                getOptionLabel={(option) => option.nombreModulo || ''}
                                value={selectedModulo}
                                onChange={(event, newValue) => setSelectedModulo(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Módulo" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>

                        { /* Fechas */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Fecha Inicio"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={fechaInicio}
                                onChange={handleFechaInicioChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Fecha Fin"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={fechaFin}
                                onChange={handleFechaFinChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                size="small"
                                variant="outlined"
                                label="Buscar Orden de Trabajo: Nombre/ Identidad/ Médico"
                                fullWidth
                                value={searchQuery}
                                onChange={handleSearchChange}
                                onKeyDown={handleKeyDown}
                            />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button variant="contained" color="primary" onClick={handleSearch} size="small">
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                size="small"
                                variant={multiSelectMode ? "contained" : "outlined"}
                                color="secondary"
                                onClick={toggleMultiSelectMode}
                                sx={{ ml: 1, minWidth: '120px', p: '4px 8px', fontSize: '0.75rem' }}
                            >
                                {multiSelectMode ? "Salir Selección Múltiple" : "Seleccionar Múltiples"}
                            </Button>
                            <Button size="small" variant="contained" color="primary" onClick={handleFactura} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Gestionar Factura OT')}>
                                Factura
                            </Button>
                            <Button size="small" variant="contained" color="primary" onClick={handleImprimirSobre} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Imprimir Orden de Trabajo')}>
                                Sobre
                            </Button>
                            <Button size="small" variant="contained" color="primary" onClick={handleImprimirEtiquetas} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Imprimir Orden de Trabajo')}>
                                Etiqueta
                            </Button>

                            <Button size="small" variant="contained" color="primary" onClick={handleReimprimirPreview} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Imprimir Resultados OT')}>
                                Reimprimir
                            </Button>
                            <Tooltip title={!puedeEnviarResultados ? tooltipEnvio : ''} arrow>
                                <span style={{ marginLeft: '5px' }}>
                                    <Button size="small" variant="contained" color="primary" onClick={handleEnviarCorreo} disabled={!puedeEnviarResultados} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                        Correo
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip title={!puedeEnviarResultados ? tooltipEnvio : ''} arrow>
                                <span style={{ marginLeft: '5px' }}>
                                    <Button size="small" variant="contained" color="primary" onClick={handleWhatsapp} disabled={!puedeEnviarResultados} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                        WhatsApp
                                    </Button>
                                </span>
                            </Tooltip>
                            <Button size="small" variant="contained" color="primary" onClick={handleImprimirTodosDetalles} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Ver Completo OT')}>
                                Ver Completo
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="primary" 
                                onClick={handleResultados} 
                                style={{ marginLeft: '5px' }} 
                                sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}
                                disabled={isOrdenAtendida || !tienePermiso('Llenar Resultados OT')
                                    //  || !facturaPagada
                                    }
                            >
                                Resultados
                            </Button>

                        </Grid>
                    </Grid>
                    {loading ? (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <Paper
                            sx={{
                            mt: 2,
                            height: 480,                 // altura fija total
                            display: 'flex',
                            flexDirection: 'column'
                            }}
                        >
                        {/* <TableContainer component={Paper} style={{ marginTop: '20px', height: 450, overflowY: 'auto' }}> */}
                            <TableContainer sx={{ flex: 1, overflowY: 'auto'}}>
                            <Table size="small" stickyHeader aria-label="detalles">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}> </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '100px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'fechaOrdenMedica'}
                                                direction={orderBy === 'fechaOrdenMedica' ? order : 'asc'}
                                                onClick={() => handleRequestSort('fechaOrdenMedica')}
                                            >
                                                Fecha
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>
                                            <TableSortLabel
                                                active={orderBy === 'idOrdenMedicaMes'}
                                                direction={orderBy === 'idOrdenMedicaMes' ? order : 'asc'}
                                                onClick={() => handleRequestSort('idOrdenMedicaMes')}
                                            >
                                                N° Orden
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '300px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'nombreCompleto'}
                                                direction={orderBy === 'nombreCompleto' ? order : 'asc'}
                                                onClick={() => handleRequestSort('nombreCompleto')}
                                            >
                                                Nombre Cliente
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'fechaEntrega'}
                                                direction={orderBy === 'fechaEntrega' ? order : 'asc'}
                                                onClick={() => handleRequestSort('fechaEntrega')}
                                            >
                                                Fecha Entrega
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>
                                            <TableSortLabel
                                                active={orderBy === 'valorVenta'}
                                                direction={orderBy === 'valorVenta' ? order : 'asc'}
                                                onClick={() => handleRequestSort('valorVenta')}
                                            >
                                                Sub Total
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>
                                            <TableSortLabel
                                                active={orderBy === 'valorDescuento'}
                                                direction={orderBy === 'valorDescuento' ? order : 'asc'}
                                                onClick={() => handleRequestSort('valorDescuento')}
                                            >
                                                Descuento
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>
                                            <TableSortLabel
                                                active={orderBy === 'valorVenta'}
                                                direction={orderBy === 'valorVenta' ? order : 'asc'}
                                                onClick={() => handleRequestSort('valorVenta')}
                                            >
                                                Total
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'}}>Estado Facturación</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '120px', textAlign: 'center' }}>
                                            <TableSortLabel
                                                active={orderBy === 'descripcionModificacion'}
                                                direction={orderBy === 'descripcionModificacion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('descripcionModificacion')}
                                            >
                                                Estado Orden
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '180px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'descripcionModificacion'}
                                                direction={orderBy === 'descripcionModificacion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('descripcionModificacion')}
                                            >
                                                Fecha ultima modificación
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '160px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'descripcionModificacion'}
                                                direction={orderBy === 'descripcionModificacion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('descripcionModificacion')}
                                            >
                                                Modificado por
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '170px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'fechaAtencion'}
                                                direction={orderBy === 'fechaAtencion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('fechaAtencion')}
                                            >
                                                Fecha atendida
                                            </TableSortLabel>
                                        </TableCell>
                                        {/* <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'fechaRecepcion'}
                                                direction={orderBy === 'fechaRecepcion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('fechaRecepcion')}
                                            >
                                                Fecha Recepcion
                                            </TableSortLabel>
                                        </TableCell> */}
                                        
                                        <TableCell sx={{ fontWeight: 'bold',  minWidth: '90px', textAlign: 'center'  }}>
                                            <TableSortLabel
                                                active={orderBy === 'entregado'}
                                                direction={orderBy === 'entregado' ? order : 'asc'}
                                                onClick={() => handleRequestSort('entregado')}
                                            >
                                                Entreg.
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Medio Entrega</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'origen'}
                                                direction={orderBy === 'origen' ? order : 'asc'}
                                                onClick={() => handleRequestSort('origen')}
                                            >
                                                Origen
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'nombreMedico'}
                                                direction={orderBy === 'nombreMedico' ? order : 'asc'}
                                                onClick={() => handleRequestSort('nombreMedico')}
                                            >
                                                Medico
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>
                                            <TableSortLabel
                                                active={orderBy === 'fechaRecepcion'}
                                                direction={orderBy === 'fechaRecepcion' ? order : 'asc'}
                                                onClick={() => handleRequestSort('fechaRecepcion')}
                                            >
                                                Fecha Recepcion
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedOrdenesTrabajo.map((ordenTrabajo) => (
                                        <TableRow 
                                            key={ordenTrabajo.idOrdenMedica}
                                            onClick={() => {
                                                // Simular clic en el checkbox cuando se hace clic en cualquier parte de la fila
                                                if (multiSelectMode) {
                                                    setSelectedMultipleOrdenes(curr => {
                                                        const isSelected = curr.some(o => o.idOrdenMedica === ordenTrabajo.idOrdenMedica);
                                                        return isSelected
                                                            ? curr.filter(o => o.idOrdenMedica !== ordenTrabajo.idOrdenMedica)
                                                            : [...curr, ordenTrabajo];
                                                    });
                                                } else {
                                                   handleSelectOrdenTrabajo(selectedOrdenTrabajo?.idOrdenMedica === ordenTrabajo.idOrdenMedica ? null : ordenTrabajo);

                                                    setSelectedOrdenTrabajo(selectedOrdenTrabajo?.idOrdenMedica === ordenTrabajo.idOrdenMedica ? null : ordenTrabajo);
                                                }
                                            }}
                                            sx={{
                                                cursor: 'pointer',
                                                backgroundColor: (multiSelectMode
                                                    ? selectedMultipleOrdenes.some(o => o.idOrdenMedica === ordenTrabajo.idOrdenMedica)
                                                    : selectedOrdenTrabajo?.idOrdenMedica === ordenTrabajo.idOrdenMedica)
                                                    ? '#e3f2fd' : 'inherit',
                                                '&:hover': {
                                                    backgroundColor: '#f5f5f5',
                                                }
                                            }}
                                        >
                                            <TableCell padding="checkbox" onClick={(e) => {
                                                // Evitar la propagación para que el clic en el checkbox no active dos veces la selección
                                                e.stopPropagation();
                                            }}>
                                                <Checkbox
                                                    size="small"
                                                    checked={
                                                        multiSelectMode
                                                            ? selectedMultipleOrdenes.some(o => o.idOrdenMedica === ordenTrabajo.idOrdenMedica)
                                                            : selectedOrdenTrabajo?.idOrdenMedica === ordenTrabajo.idOrdenMedica
                                                    }
                                                    onChange={(e) => {
                                                        // Detener la propagación para evitar que el evento llegue a la fila
                                                        e.stopPropagation();
                                                        if (multiSelectMode) {
                                                            // Toggle en el array de múltiples
                                                            setSelectedMultipleOrdenes(curr => {
                                                                const exists = curr.some(o => o.idOrdenMedica === ordenTrabajo.idOrdenMedica);
                                                                if (exists) return curr.filter(o => o.idOrdenMedica !== ordenTrabajo.idOrdenMedica);
                                                                return [...curr, ordenTrabajo];
                                                            });
                                                        } else {
                                                            // Modo simple: sigue funcionando como antes
                                                            handleSelectOrdenTrabajo(ordenTrabajo);
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaOrdenMedica).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{ordenTrabajo.abreviatura}{ordenTrabajo.idOrdenMedicaMes}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{ordenTrabajo.nombreCompleto}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaEntrega).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                                            {/* <TableCell style={{ padding: '4px' }}>{(Number(ordenTrabajo.valorVenta) + Number(ordenTrabajo.valorDescuento)).toFixed(2)}</TableCell> */}
                                            <TableCell style={{ padding: '4px' }}>{(ordenTrabajo.valorVenta).toFixed(2)}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{(ordenTrabajo.valorDescuento).toFixed(2)}</TableCell>
                                            {/* <TableCell style={{ padding: '4px' }}>{(ordenTrabajo.valorVenta).toFixed(2)}</TableCell> */}
                                            {/* <TableCell style={{ padding: '4px' }}>{(Number(ordenTrabajo.valorVenta) - Number(ordenTrabajo.valorDescuento).toFixed(2) - Number(ordenTrabajo.puntos).toFixed(2))}</TableCell> */}
                                            <TableCell style={{ padding: '4px' }}>{(Number(ordenTrabajo.valorVenta) - Number(ordenTrabajo.valorDescuento) - Number(ordenTrabajo.puntos)).toFixed(2)}</TableCell>
                                            <TableCell style={{ padding: '2px', textAlign: 'center', width: '26px' }}>
                                                <FacturacionStatusIcon idOrdenMedica={ordenTrabajo.idOrdenMedica} />
                                            </TableCell>
                                            <TableCell style={{ padding: '1px', textAlign:'center' }}> {ordenTrabajo.modificacion === 1 ? "Pendiente" : ordenTrabajo.descripcionModificacion}</TableCell>
                                            <TableCell style={{ padding: '4px' }}> {ordenTrabajo.fechaModificacion ? dayjs(ordenTrabajo.fechaModificacion).format('DD/MM/YYYY hh:mm:ss A') : 'N/A'}</TableCell>
                                            <TableCell style={{ padding: '2px' }}> {ordenTrabajo.modificadoPor ?? 'N/A'}</TableCell>

                                            <TableCell style={{ padding: '4px' }}>{ordenTrabajo.fechaAtendida ? dayjs(ordenTrabajo.fechaAtendida).format('DD/MM/YYYY hh:mm:ss A') : 'N/A'}</TableCell>
                                             {/* <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaRecepcion).format('DD/MM/YYYY hh:mm:ss A')}</TableCell> */}
                                            <TableCell style={{ padding: '1px', textAlign: 'center', width: '24px'  }}>{ordenTrabajo.entregado ? 'Si' : 'No'}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>
                                                {ordenTrabajo.enviarXWhatsapp && <FontAwesomeIcon icon={faWhatsapp} title="WhatsApp" style={{ margin: '0 2px', color: ordenTrabajo.entregado ? '#25D366' : 'inherit' }} />}
                                                {ordenTrabajo.enviarXApp && <FontAwesomeIcon icon={faMobileAlt} title="App" style={{ margin: '0 2px', color: ordenTrabajo.entregado ? '#4CAF50' : 'inherit' }} />}
                                                {ordenTrabajo.enviarXCorreo && <FontAwesomeIcon icon={faEnvelope} title="Email" style={{ margin: '0 2px', color: ordenTrabajo.entregado ? '#4CAF50' : 'inherit' }} />}
                                                {ordenTrabajo.imprimir && <FontAwesomeIcon icon={faPrint} title="Impreso" style={{ margin: '0 2px', color: ordenTrabajo.entregado ? '#4CAF50' : 'inherit' }} />}
                                                {!ordenTrabajo.enviarXWhatsapp && !ordenTrabajo.enviarXApp && !ordenTrabajo.enviarXCorreo && !ordenTrabajo.imprimir && 'N/A'}
                                            </TableCell>
                                            <TableCell style={{ padding: '4px' }}>{ordenTrabajo.origen ? ordenTrabajo.origen : 'N/A'}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{ordenTrabajo.nombreMedico ? ordenTrabajo.nombreMedico : 'N/A'}</TableCell>
                                            <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaRecepcion).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            </TableContainer>
                            
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100, 200]}
                                component="div"
                                count={totalOrdenesTrabajo}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => {
                                    const displayTo = Math.min(to, ordenesTrabajo.length);
                                    const loaded = ordenesTrabajo.length;
                                    return `${from}-${displayTo} de ${loaded} cargados (${totalOrdenesTrabajo} total)`;
                                }}
                                sx={{
                                    borderTop: '1px solid #e0e0e0',
                                    backgroundColor: 'background.paper'
                                }}
                            />
                     </Paper>
                    )}
                    {loadingMore && (
                        <div style={{ textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}>
                            <CircularProgress size={24} />
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                Cargando más órdenes...
                            </Typography>
                        </div>
                    )}

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleModificar} 
                                style={{ marginLeft: '5px' }} 
                                sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}
                                disabled={isOrdenAtendida || !tienePermiso('Editar OT Listado')}
                            >
                                Modificar
                            </Button>
                            {/* <Button variant="contained" color="primary" onClick={handleDividir} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                Dividir Orden
                            </Button> */}
                            <Button variant="contained" color="primary" onClick={handleAtendida} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!tienePermiso('Cambiar Estado OT')}>
                                Atendida
                            </Button>
                            <Tooltip title={!selectedOrdenTrabajo ? 'Seleccione una orden de trabajo.' : verificandoPago ? "Verificando estado de factura..." : !facturaPagada ? (motivoBloqueo || 'La factura no está totalmente pagada.') : 'Marcar como entregada'}>
                                <span style={{ marginLeft: '5px' }}>
                                    <Button variant="contained" color="primary" onClick={handleEntregada} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}
                                        disabled={!tienePermiso('Cambiar Estado OT') || !selectedOrdenTrabajo || verificandoPago || !facturaPagada                                    }>
                                        Entregada
                                    </Button>
                                </span>
                            </Tooltip>
                            <Button variant="contained" color="warning" onClick={handleReactivar} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }} disabled={!isOrdenAtendida || !tienePermiso('Cambiar Estado OT')}>
                                Reactivar
                            </Button>
                            {/* <Button variant="contained" color="primary" onClick={handleAnular} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                Anular
                            </Button> */}
                        </Grid>
                    </Grid>

                    {selectedOrdenTrabajo && (
                        <>

                            <h2>Detalles de la Orden de Trabajo</h2>
                            
                            {/* Debug: mostrar información de módulos */}
                            {console.log('Estado actual modulosDetalles:', modulosDetalles)}
                            
                            {/* Filtro de módulos - temporalmente siempre visible para depuración */}
                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        size="small"
                                        value={selectedModuloDetalle}
                                        onChange={handleModuloDetalleChange}
                                        options={[null, ...modulosDetalles]}
                                        getOptionLabel={(option) => option || 'Todos los módulos'}
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                label={`Filtrar por Módulo (${modulosDetalles.length} disponibles)`}
                                                variant="outlined"
                                            />
                                        )}
                                        isOptionEqualToValue={(option, value) => option === value}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {/* <Button variant="contained" color="primary" onClick={handleResultados}>
                                                                        Resultados
                                                                    </Button> */}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>

                                <Grid item xs={8}> {/* Esto centra horizontalmente el Grid */}
                                    {detallesOrdenTrabajo.length > 0 ? (
                                        <>
                                            {detallesFiltrados.length > 0 ? (
                                                <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                    <Table size="small" aria-label="detalles"
                                                        sx={{
                                                            // Opcional: fuerza menor padding vertical en todas las celdas
                                                            '& .MuiTableCell-root': {
                                                                py: 0.5,
                                                                px: 1
                                                            }
                                                        }}
                                                    >
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center" padding="checkbox" sx={{width: '5%', fontWeight: 'bold' }}>
                                                                    <Checkbox
                                                                        checked={todosDetallesSeleccionados}
                                                                        indeterminate={algunosDetallesSeleccionados}
                                                                        onChange={toggleSelectAllDetalles}
                                                                        size="small"
                                                                        title="Seleccionar todos"
                                                                        disabled={false}
                                                                    />todos
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 100 }}>Descripción</TableCell>
                                                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Tipo Precio</TableCell>
                                                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Comentario</TableCell>
                                                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Estado</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* IMPORTANTE: Se renderizan los detalles en el orden exacto que vienen de la API 
                                                        SIN aplicar ningún ordenamiento por estado o cualquier otro campo */}
                                                    {detallesFiltrados
                                                        .map((detalle) => {
                                                        const rowStyle = {};

                                                        return (
                                                            <TableRow key={detalle.idDetalle} sx={rowStyle}>
                                                                <TableCell align="center" padding="checkbox">
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={selectedDetalles.some(d => d.idDetalle === detalle.idDetalle)}
                                                                        onChange={() => toggleDetalleSelection(detalle)}
                                                                        disabled={false}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="left">{detalle.descripcionTipoAnalisis}</TableCell>
                                                                <TableCell align="center">{detalle.descripcionTipoPrecio}</TableCell>
                                                                <TableCell align="center">{detalle.comentarios}</TableCell>
                                                                <TableCell align="center">{detalle.valorVenta}</TableCell>
                                                                <TableCell align="center">{detalle.tipoValidacion}</TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                            ) : (
                                                <Alert severity="info" sx={{ mt: 2 }}>
                                                    No hay análisis que coincidan con el filtro seleccionado.
                                                </Alert>
                                            )}
                                        </>
                                    ) : (
                                        <p>No hay detalles disponibles para esta orden de trabajo.</p>
                                    )}
                                </Grid>

                                <Grid item xs={4}>
                                    <Grid container spacing={1.5}>
                                        <Grid item xs={6}>
                                            <Grid container direction="column" spacing={1.5} alignItems="center">
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handlePrevalidarMultiple}
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        disabled={isOrdenAtendida || !todosLosSeleccionadosPuedenPrevalidar() || !tienePermiso('Prevalidar OT')}
                                                    >
                                                        Prevalidar
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleValidarMultiple}
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        disabled={isOrdenAtendida || !todosLosSeleccionadosPuedenValidar() || !tienePermiso('Validar OT')}
                                                    >
                                                        Validar
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={!selectedOrdenTrabajo ? 'Seleccione una orden de trabajo.' : verificandoPago ? "Verificando estado de factura..." : !facturaPagada ? (motivoBloqueo || 'La factura no está totalmente pagada.') : 'Marcar como entregada'}>
                                                        <span>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleImprimirDetalles}
                                                                sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                                disabled={!tienePermiso('Imprimir Detalle OT') || !selectedOrdenTrabajo || verificandoPago || !facturaPagada}
                                                            >
                                                                Imprimir
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        onClick={() => {
                                                            if (selectedOrdenTrabajo) {
                                                                if (selectedDetalles.length === 0) {
                                                                    Swal.fire({ text: 'Selecciona al menos un análisis.', icon: 'warning' });
                                                                    return;
                                                                }
                                                                setOpenTomaMuestra(true);
                                                            } else {
                                                                Swal.fire({ text: 'Primero debes seleccionar una orden de trabajo.', icon: 'warning' });
                                                            }
                                                        }}
                                                        disabled={!tienePermiso('Toma Muestra OT')}
                                                    >
                                                        Toma Muestra
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid container direction="column" spacing={1.5} alignItems="center">
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleQuitarPrevalidarMultiple}
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        disabled={isOrdenAtendida || !todosLosSeleccionadosPuedenQuitarPrevalidacion() || !tienePermiso('Quitar Prevalidación OT')}
                                                    >
                                                        Quitar PreV.
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleInvalidarMultiple}
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        disabled={isOrdenAtendida || !todosLosSeleccionadosPuedenInvalidar() || !tienePermiso('Invalidar OT')}
                                                    >
                                                        Invalidar
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="warning"
                                                        sx={{ minWidth: '120px', padding: '6px 10px', fontSize: '0.75rem' }}
                                                        onClick={handleReprocesar}
                                                        disabled={!tienePermiso('Reprocesar Análisis') || !selectedDetalles.some(d => d.idTipoAprobacion > 0)}
                                                    >
                                                        Reprocesar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* <Grid item xs={6}>
                                            <Button variant="contained" color="primary" onClick={handleImprimirTodosDetalles} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                Imprimir todos
                                            </Button>
                                        </Grid> */}
                                        <Grid item xs={12}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                            mt: 2,
                                            p: 1,
                                            minHeight: 120,
                                            fontSize: '0.75rem'
                                            }}
                                        >

                                            <h2>Comentarios de entrega</h2>

                                            <TableContainer
                                                    sx={{
                                                        maxHeight: 200,
                                                        overflowY: 'auto',    // scroll vertical
                                                        overflowX: 'auto',
                                                    }}
                                                >
                                            <Table size="small" stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ minWidth: 250 }}><strong>Comentario</strong></TableCell>
                                                        <TableCell sx={{ minWidth: 150 }}><strong>Fecha</strong></TableCell>
                                                        <TableCell sx={{ minWidth: 150 }}><strong>Usuario</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                {comentariosEntregaPorOrden?.$values?.length > 0 ? (
                                                        comentariosEntregaPorOrden.$values.map((item) => (
                                                            <TableRow key={item.id}>
                                                                <TableCell  sx={{ minWidth: 250 }}>{item.comentarios}</TableCell>
                                                                <TableCell  sx={{ minWidth: 150 }}>{formatoFecha(item.fechaIngreso)}</TableCell>
                                                                <TableCell  sx={{ minWidth: 150 }}>{item.ingresadoPor}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center">
                                                        No hay comentarios
                                                        </TableCell>
                                                    </TableRow>
                                                    )}
                                                </TableBody>

                                            </Table>
                                            </TableContainer>
                                        </Paper>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    )}


                    <Modal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <div style={modalStyle}>
                            {ordenTrabajoData && (
                                <GestionOrdenTrabajo
                                    ordenTrabajo={ordenTrabajoData.OrdenTrabajo}
                                    modo={ordenTrabajoData.modo}
                                    onClose={async (result) => {
                                        setOpenModal(false);
                                        
                                        // Si result contiene datos para facturación directa
                                        if (result && result.shouldOpenFactura && result.ordenData) {
                                            // Preparar datos para facturación
                                            setFacturaData({
                                                multiple: false,
                                                ordenTrabajo: result.ordenData.idOrdenMedica,
                                                nombreCliente: result.ordenData.nombreCompleto,
                                                identidad: result.ordenData.Identidad,
                                                valorPagar: result.ordenData.valorVenta,
                                                valorVenta: result.ordenData.valorVenta,
                                                valorDescuento: result.ordenData.valorDescuento,
                                                idSucursal: result.ordenData.idSucursal,
                                                idCliente: result.ordenData.idCliente
                                            });
                                            
                                            // Abrir modal de facturación directamente
                                            setOpenFacturaModal(true);
                                        } else {
                                            // Comportamiento normal: actualizar listado y selección
                                            await fetchOrdenesTrabajos(searchQuery);
                                            const ordenActualizada = await fetch(`${server}/MgOrdenesMedicas/${ordenTrabajoData.OrdenTrabajo.idOrdenMedica}`);
                                            if (ordenActualizada.ok) {
                                                const data = await ordenActualizada.json();
                                                await handleSelectOrdenTrabajo(data);
                                            }
                                        }
                                    }}

                                />
                            )}
                        </div>
                    </Modal>
                    <Modal
                        open={openFacturaModal}
                        onClose={handleCloseFacturaModal}
                        aria-labelledby="modal-title-factura"
                        aria-describedby="modal-description-factura"
                    >
                        <div style={modalStyle}>
                            {facturaData && (
                                <GestionFactura
                                    datosFactura={facturaData}
                                    onClose={handleCloseFacturaModal}
                                />
                            )}
                        </div>
                    </Modal>

                    {openResultadosModal && (
                        <Resultados
                            open={true}
                            handleClose={handleCloseResultados}
                            OrdenTrabajo={numericCodigo}
                            detalleSeleccionado={detalleSeleccionado}
                        />
                    )}

                    <Modal 
                        open={openTomaMuestra} 
                        onClose={() => setOpenTomaMuestra(false)}
                        slotProps={{
                            backdrop: {
                                style: { zIndex: 1300 }
                            }
                        }}
                        sx={{ zIndex: 1300 }}
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '98%', sm: '95%', md: '85%' },
                            maxHeight: { xs: '98vh', sm: '95vh' },
                            overflowY: 'auto',
                            backgroundColor: 'white',
                            padding: '2px',
                            borderRadius: '4px',
                            zIndex: 1301
                        }}>
                            <TomaMuestra
                                selectedOrden={selectedOrdenTrabajo}
                                selectedDetalles={selectedDetalles}
                                open={openTomaMuestra}
                                onClose={() => setOpenTomaMuestra(false)}
                            />
                        </Box>
                    </Modal>                    

                    {/* Modal de Reprocesar Análisis */}
                    <Dialog
                        open={openReprocesarModal}
                        onClose={() => !procesandoReproceso && setOpenReprocesarModal(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle sx={{ fontWeight: 'bold', color: '#ed6c02' }}>
                            Reprocesar Análisis
                            <Typography variant="subtitle2" color="textSecondary">
                                {selectedDetalles.length} análisis seleccionado(s)
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ mt: 1 }}>
                                <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
                                    <InputLabel>Motivo de Reproceso (requerido)</InputLabel>
                                    <Select
                                        value={motivoReprocesoSeleccionado}
                                        onChange={(e) => setMotivoReprocesoSeleccionado(e.target.value)}
                                        label="Motivo de Reproceso (requerido)"
                                        disabled={cargandoMotivosReproceso || procesandoReproceso}
                                    >
                                        {cargandoMotivosReproceso ? (
                                            <MenuItem disabled>
                                                <CircularProgress size={20} sx={{ mr: 1 }} />
                                                Cargando motivos...
                                            </MenuItem>
                                        ) : (
                                            motivosReproceso.map((motivo) => (
                                                <MenuItem key={motivo.id} value={motivo.id}>
                                                    {motivo.descripcion}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                </FormControl>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <TextField
                                        fullWidth
                                        label="Primer Resultado (requerido)"
                                        value={primerResultado}
                                        onChange={(e) => setPrimerResultado(e.target.value)}
                                        variant="outlined"
                                        disabled={procesandoReproceso}
                                    />
                                    <TextField
                                        fullWidth
                                        label="Resultado Confirmación (requerido)"
                                        value={confirmacionResultado}
                                        onChange={(e) => setConfirmacionResultado(e.target.value)}
                                        variant="outlined"
                                        disabled={procesandoReproceso}
                                    />
                                </Box>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenReprocesarModal(false)}
                                color="secondary"
                                variant="outlined"
                                disabled={procesandoReproceso}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleConfirmReproceso}
                                color="warning"
                                variant="contained"
                                disabled={procesandoReproceso || !motivoReprocesoSeleccionado || !primerResultado.trim() || !confirmacionResultado.trim()}
                                startIcon={procesandoReproceso ? <CircularProgress size={16} /> : null}
                            >
                                Confirmar Reproceso
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <ComentariosEntregaModal
                        open={openComentarioEntrega}
                        initialComentarios={comentariosEntrega}
                        onClose={() => setOpenComentarioEntrega(false)}
                        onSave={guardarComentarioEntrega}
                    />                    
                    <PdfPreviewModal
                        open={openPdfPreview}
                        onConfirm={handlePdfPreviewConfirm}
                        onClose={handlePdfPreviewCancel}
                        selectedDetalles={pendingValidationAction?.detalles || (selectedDetalles.length > 0 ? selectedDetalles : (detalleSeleccionado ? [detalleSeleccionado] : []))}
                        actionType={pendingValidationAction?.type}
                    />

                    <SobrePreviewModal
                        open={openSobrePreview}
                        onClose={handleCloseSobrePreview}
                        onConfirm={handleSobrePreviewConfirm}
                        selectedOrden={selectedOrdenTrabajo}
                        title="Vista Previa del Sobre"
                        confirmText="Imprimir"
                        cancelText="Cancelar"
                    />

                    <Dialog
                        open={openLabelModal}
                        onClose={handleCloseLabelModal}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>
                            Seleccionar Muestras para Etiquetas
                        </DialogTitle>
                        <DialogContent>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={
                                            availableSamples.length > 0 && 
                                            availableSamples.every(m => selectedSamples.includes(m.idMuestraXAnalisis))
                                        }
                                        onChange={(e) => handleSelectAllSamples(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Seleccionar todas las muestras"
                            />
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold', width: '80px' }}>Seleccionar</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', minWidth: '100px' }}>Módulo</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', minWidth: '150px' }}>Descripción</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', width: '80px' }}>Cant.</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', minWidth: '200px' }}>Exámenes</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', width: '100px' }}>Cobas 303</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {availableSamples.map((muestra, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedSamples.includes(muestra.idMuestraXAnalisis)}
                                                        onChange={(e) => handleSampleSelectionChange(muestra, e.target.checked)}
                                                    />
                                                </TableCell>
                                                    <TableCell>{muestra.modulo}</TableCell>
                                                    <TableCell>{muestra.descripcionMuestra}</TableCell>
                                                    <TableCell>{muestra.descripcionCantidad}</TableCell>
                                                    <TableCell>
                                                        <Box sx={{ fontSize: '0.85rem' }}>
                                                            {muestra.ComparteCon}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Checkbox
                                                            checked={muestra.esCobas303 || false}
                                                            onChange={(e) => {
                                                                const updatedSamples = [...availableSamples];
                                                                updatedSamples[index] = {
                                                                    ...muestra,
                                                                    esCobas303: e.target.checked
                                                                };
                                                                setAvailableSamples(updatedSamples);
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseLabelModal} color="secondary" variant="outlined">
                                Cancelar
                            </Button>
                            <Button
                                onClick={handlePrintSelectedLabels}
                                color="primary"
                                variant="contained"
                                disabled={selectedSamples.length === 0}
                            >
                                Imprimir Etiquetas
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Modal
                        open={openReimprimirPreview}
                        onClose={handleCloseReimprimirPreview}
                        aria-labelledby="modal-title-reimprimir"
                        aria-describedby="modal-description-reimprimir"
                    >
                        <div style={fullScreenModalStyle}>
                            <Box style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                marginBottom: '20px',
                                borderBottom: '1px solid #eee',
                                paddingBottom: '10px'
                            }}>
                                <h2 style={{ margin: 0 }}>Vista Previa de Reimpresión</h2>
                                <Button 
                                    onClick={handleCloseReimprimirPreview}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    Cerrar
                                </Button>
                            </Box>
                            {reimprimirLoading && (
                                <Box 
                                    display="flex" 
                                    flexDirection="column" 
                                    alignItems="center" 
                                    justifyContent="center" 
                                    flex={1}
                                    minHeight="50vh"
                                >
                                    <CircularProgress 
                                        size={60} 
                                        sx={{ 
                                            '@keyframes spin': {
                                                '0%': { transform: 'rotate(0deg)' },
                                                '100%': { transform: 'rotate(360deg)' }
                                            },
                                            animation: 'spin 0.5s linear infinite'
                                        }}
                                    />
                                    <Typography variant="body1" style={{ marginTop: 16 }}>
                                        Generando vista previa del PDF...
                                    </Typography>
                                </Box>
                            )}
                            {reimprimirError && (
                                <Box 
                                    p={3}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    flex={1}
                                    minHeight="50vh"
                                >
                                    <Alert severity="error" style={{ maxWidth: '600px' }}>
                                        {reimprimirError}
                                    </Alert>
                                </Box>
                            )}
                            {reimprimirPdfUrl && !reimprimirLoading && !reimprimirError && (
                                <Box style={{ 
                                    flex: 1, 
                                    height: '100%',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <iframe
                                        src={reimprimirPdfUrl}
                                        style={{ 
                                            width: '100%', 
                                            height: '100%', 
                                            border: 'none', 
                                            flex: 1
                                        }}
                                        title="Vista previa del PDF"
                                    />
                                </Box>
                            )}
                        </div>
                    </Modal>

                    {/* Modal de Preview de Etiquetas */}
                    <Modal
                        open={openEtiquetasPreview}
                        onClose={() => {
                            setOpenEtiquetasPreview(false);
                            if (etiquetasPdfUrl) {
                                window.URL.revokeObjectURL(etiquetasPdfUrl);
                                setEtiquetasPdfUrl(null);
                            }
                        }}
                    >
                        <div style={fullScreenModalStyle}>
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                pb: 2,
                                mb: 2
                            }}>
                                <h2 style={{ margin: 0 }}>
                                    Etiquetas de Muestras - Orden #{selectedOrdenTrabajo?.idOrdenMedicaMes || selectedOrdenTrabajo?.idOrdenMedica}
                                </h2>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <button
                                        onClick={() => {
                                            if (etiquetasPdfUrl) {
                                                const a = document.createElement('a');
                                                a.href = etiquetasPdfUrl;
                                                a.download = `Etiquetas_Orden_${selectedOrdenTrabajo.idOrdenMedica}.pdf`;
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                                
                                                Swal.fire({
                                                    title: 'Descargado',
                                                    text: 'El PDF se ha descargado correctamente',
                                                    icon: 'success',
                                                    timer: 2000,
                                                    showConfirmButton: false
                                                });
                                            }
                                        }}
                                        style={{
                                            backgroundColor: '#1976d2',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Descargar PDF
                                    </button>
                                    <button
                                        onClick={() => {
                                            setOpenEtiquetasPreview(false);
                                            if (etiquetasPdfUrl) {
                                                window.URL.revokeObjectURL(etiquetasPdfUrl);
                                                setEtiquetasPdfUrl(null);
                                            }
                                        }}
                                        style={{
                                            backgroundColor: '#d32f2f',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Cerrar
                                    </button>
                                </Box>
                            </Box>
                            {etiquetasPdfUrl && (
                                <Box style={{ 
                                    flex: 1, 
                                    height: 'calc(100% - 80px)',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <iframe
                                        src={etiquetasPdfUrl}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            border: 'none',
                                            flexGrow: 1
                                        }}
                                        title="Preview Etiquetas"
                                    />
                                </Box>
                            )}
                        </div>
                    </Modal>

                    {/* Modal de Preview de Orden */}
                    <Modal
                        open={openOrdenPreview}
                        onClose={() => {
                            setOpenOrdenPreview(false);
                            if (ordenPdfUrl) {
                                window.URL.revokeObjectURL(ordenPdfUrl);
                                setOrdenPdfUrl(null);
                            }
                        }}
                    >
                        <div style={fullScreenModalStyle}>
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                pb: 2,
                                mb: 2
                            }}>
                                <h2 style={{ margin: 0 }}>
                                    Orden de Trabajo - #{selectedOrdenTrabajo?.idOrdenMedicaMes || selectedOrdenTrabajo?.idOrdenMedica}
                                </h2>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <button
                                        onClick={() => {
                                            if (ordenPdfUrl) {
                                                const a = document.createElement('a');
                                                a.href = ordenPdfUrl;
                                                a.download = `Orden_${selectedOrdenTrabajo.idOrdenMedica}.pdf`;
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                                
                                                Swal.fire({
                                                    title: 'Descargado',
                                                    text: 'El PDF se ha descargado correctamente',
                                                    icon: 'success',
                                                    timer: 2000,
                                                    showConfirmButton: false
                                                });
                                            }
                                        }}
                                        style={{
                                            backgroundColor: '#1976d2',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Descargar PDF
                                    </button>
                                    <button
                                        onClick={() => {
                                            setOpenOrdenPreview(false);
                                            if (ordenPdfUrl) {
                                                window.URL.revokeObjectURL(ordenPdfUrl);
                                                setOrdenPdfUrl(null);
                                            }
                                        }}
                                        style={{
                                            backgroundColor: '#d32f2f',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Cerrar
                                    </button>
                                </Box>
                            </Box>
                            {ordenPdfUrl && (
                                <Box style={{ 
                                    flex: 1, 
                                    height: 'calc(100% - 80px)',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <iframe
                                        src={ordenPdfUrl}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            border: 'none',
                                            flexGrow: 1
                                        }}
                                        title="Preview Orden de Trabajo"
                                    />
                                </Box>
                            )}
                        </div>
                    </Modal>

                </div>
            </div>
        </>
    );
}

export default OrdenesTrabajo;
